import type { SVGProps } from 'react';

export const Chart = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <g clipPath='url(#clip0_282_43960)'>
          <path
            d='M17.6759 13.3529C17.1457 14.6067 16.3165 15.7115 15.2607 16.5708C14.2049 17.4301 12.9547 18.0176 11.6193 18.2821C10.284 18.5466 8.9042 18.4799 7.60057 18.0879C6.29695 17.696 5.10919 16.9906 4.14114 16.0335C3.17309 15.0765 2.45422 13.8969 2.04739 12.5978C1.64055 11.2987 1.55814 9.91979 1.80734 8.58151C2.05655 7.24324 2.6298 5.98639 3.47696 4.92084C4.32413 3.85529 5.41942 3.01349 6.66707 2.46903M10.0006 10.1111V1.77734C15.0008 1.77734 18.3343 5.94421 18.3343 10.1111H10.0006Z'
            stroke='#4E4F52'
            strokeWidth='1.66674'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_282_43960'>
            <rect
              width='20.0009'
              height='20.0009'
              fill='white'
              transform='translate(0 0.110596)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const CopyIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='feather feather-copy'
      >
        <rect x='9' y='9' width='13' height='13' rx='2' ry='2'></rect>
        <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'></path>
      </svg>
    </>
  );
};

export const Details = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          d='M2.5 15.1113H2.50833M6.66686 5.11084H17.5007M6.66686 10.1111H17.5007M6.66686 15.1113H17.5007M2.5 5.11084H2.50833M2.5 10.1111H2.50833'
          stroke='#4E4F52'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const Products = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <g clipPath='url(#clip0_389_13665)'>
          <path
            d='M10.0002 18.4441H3.33343C2.41295 18.4441 1.66675 17.6979 1.66675 16.7774V3.44391C1.66675 2.52342 2.41295 1.77722 3.33344 1.77722H16.6669C17.5874 1.77722 18.3336 2.52342 18.3336 3.44391V10.944'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeMiterlimit='16'
            strokeLinecap='round'
          />
          <path
            d='M18.3339 14.278L14.1672 18.4447L12.5005 16.778'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.3335 5.1106C13.3335 5.99466 12.9823 6.84252 12.3572 7.46765C11.732 8.09278 10.8842 8.44397 10.0001 8.44397C9.11606 8.44397 8.2682 8.09278 7.64307 7.46765C7.01794 6.84252 6.66675 5.99466 6.66675 5.1106'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_389_13665'>
            <rect
              width='20.0009'
              height='20.0009'
              fill='white'
              transform='translate(0 0.110596)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Transaction = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <g clipPath='url(#clip0_282_44024)'>
          <path
            d='M1.66675 1.77734V18.4442'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
          />
          <path
            d='M18.3335 1.77734V18.4442'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
          />
          <path
            d='M13.3336 5.11084L15.0002 6.77753L13.3336 8.44421'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
          />
          <path
            d='M1.66684 6.77734L14.167 6.77734'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
          />
          <path
            d='M6.66669 11.7778L5 13.4445L6.66669 15.1112'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
          />
          <path
            d='M18.3336 13.4443L5.8335 13.4443'
            stroke='#4E4F52'
            strokeWidth='1.66669'
            strokeLinecap='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_282_44024'>
            <rect
              width='20.0009'
              height='20.0009'
              fill='white'
              transform='translate(0 0.11084)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Offer = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          d='M7.89844 12.1106L11.8984 8.1106'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <path
          d='M8.20909 2.65919C9.16491 1.78301 10.632 1.783 11.5878 2.65918L12.349 3.35695C12.7117 3.68949 13.1646 3.90757 13.6508 3.98386L14.6709 4.14393C15.9519 4.34493 16.8666 5.49192 16.7775 6.7855L16.7065 7.81567C16.6727 8.30663 16.7846 8.79666 17.0281 9.22433L17.5389 10.1217C18.1805 11.2485 17.854 12.6788 16.7871 13.4157L15.9375 14.0025C15.5325 14.2822 15.2191 14.6752 15.0366 15.1322L14.6535 16.0911C14.1725 17.2952 12.8508 17.9318 11.6094 17.5571L10.6209 17.2587C10.1497 17.1165 9.64713 17.1165 9.17599 17.2587L8.18744 17.5571C6.94611 17.9318 5.62435 17.2952 5.14334 16.0911L4.76029 15.1322C4.57773 14.6752 4.26434 14.2822 3.85941 14.0025L3.00976 13.4157C1.94286 12.6788 1.61641 11.2485 2.25793 10.1217L2.76882 9.22433C3.01231 8.79666 3.12415 8.30663 3.09034 7.81567L3.0194 6.7855C2.93032 5.49192 3.84501 4.34493 5.12598 4.14393L6.14611 3.98386C6.63228 3.90757 7.08513 3.68949 7.44791 3.35695L8.20909 2.65919Z'
          stroke='#4E4F52'
          strokeWidth='1.66669'
        />
        <circle
          cx='11.3984'
          cy='12.6106'
          r='0.5'
          stroke='#4E4F52'
          strokeWidth='1.66669'
        />
        <circle
          cx='8.39844'
          cy='7.6106'
          r='0.5'
          stroke='#4E4F52'
          strokeWidth='1.66669'
        />
      </svg>
    </>
  );
};

export const Quote = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          d='M1.66675 18.4442V15.1108C1.66675 14.1903 2.41295 13.4441 3.33343 13.4441H4.16678M18.3336 18.4442V15.1108C18.3336 14.1903 17.5874 13.4441 16.6669 13.4441H15.8336'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeMiterlimit='16'
          strokeLinecap='round'
        />
        <path
          d='M4.16675 15.9441V4.49994C4.16675 3.49519 5.38153 2.99201 6.092 3.70247C6.43525 4.04572 6.95964 4.13082 7.39382 3.91373L9.25479 2.98325C9.72401 2.74864 10.2763 2.74864 10.7455 2.98325L12.6065 3.91373C13.0407 4.13082 13.5651 4.04572 13.9083 3.70247C14.6188 2.99201 15.8336 3.49519 15.8336 4.49994V15.9441C15.8336 16.8645 15.0874 17.6107 14.1669 17.6107H5.83344C4.91295 17.6107 4.16675 16.8645 4.16675 15.9441Z'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeMiterlimit='16'
          strokeLinecap='round'
        />
        <line
          x1='7.50009'
          y1='9.27737'
          x2='12.5002'
          y2='9.27738'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <line
          x1='7.50009'
          y1='12.6107'
          x2='12.5002'
          y2='12.6107'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
      </svg>
    </>
  );
};
export const Submission = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <g clipPath='url(#clip0_389_13701)'>
          <path
            d='M11.6672 1.77734H5.00024C4.55819 1.77734 4.13425 1.95295 3.82167 2.26552C3.5091 2.5781 3.3335 3.00204 3.3335 3.44409V16.778C3.3335 17.2201 3.5091 17.644 3.82167 17.9566C4.13425 18.2692 4.55819 18.4448 5.00024 18.4448H15.0007C15.4428 18.4448 15.8667 18.2692 16.1793 17.9566C16.4918 17.644 16.6675 17.2201 16.6675 16.778V6.77758M11.6672 1.77734V6.77758H16.6675M11.6672 1.77734L16.6675 6.77758'
            stroke='#4E4F52'
            strokeWidth='1.66674'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.334 10.9443H6.66699M13.334 14.2778H6.66699M8.33374 7.61084H7.50036H6.66699'
            stroke='#4E4F52'
            strokeWidth='1.66674'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_389_13701'>
            <rect
              width='20.0009'
              height='20.0009'
              fill='white'
              transform='translate(0 0.110596)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Gateways = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          d='M16.6669 7.61075H3.33343C2.41295 7.61075 1.66675 6.86455 1.66675 5.94406V5.51744C1.66675 4.78142 2.14953 4.13254 2.85452 3.92104L9.52126 1.92102C9.83366 1.8273 10.1667 1.8273 10.4791 1.92102L17.1458 3.92104C17.8508 4.13254 18.3336 4.78142 18.3336 5.51744V5.94406C18.3336 6.86455 17.5874 7.61075 16.6669 7.61075Z'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <path
          d='M16.6669 18.4442H3.33344C2.41295 18.4442 1.66675 17.698 1.66675 16.7775C1.66675 15.857 2.41295 15.1108 3.33344 15.1108H10.0002H16.6669C17.5874 15.1108 18.3336 15.857 18.3336 16.7775C18.3336 17.698 17.5874 18.4442 16.6669 18.4442Z'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <path
          d='M4.16675 7.6106V15.1107'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <path
          d='M10 7.6106V15.1107'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <path
          d='M15.8335 7.6106V15.1107'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
      </svg>
    </>
  );
};
export const Payment = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          d='M0.833252 8.44433H19.1674M2.5 3.44409H17.5007C18.4212 3.44409 19.1674 4.19032 19.1674 5.11084V15.1113C19.1674 16.0318 18.4212 16.778 17.5007 16.778H2.5C1.57948 16.778 0.833252 16.0318 0.833252 15.1113V5.11084C0.833252 4.19032 1.57948 3.44409 2.5 3.44409Z'
          stroke='#4E4F52'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const MultiAccount = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          d='M14.1672 17.6113V15.9446C14.1672 15.0605 13.816 14.2126 13.1909 13.5874C12.5657 12.9623 11.7178 12.6111 10.8337 12.6111H4.16674C3.28264 12.6111 2.43476 12.9623 1.80961 13.5874C1.18446 14.2126 0.833252 15.0605 0.833252 15.9446V17.6113M19.1674 17.6113C19.1674 15.1112 19.1674 13.8611 16.6673 12.6111M13.3338 2.71893C14.0509 2.90252 14.6864 3.31954 15.1403 3.90425C15.5941 4.48895 15.8405 5.20807 15.8405 5.94825C15.8405 6.68843 15.5941 7.40755 15.1403 7.99225C14.6864 8.57695 14.0509 8.99397 13.3338 9.17757M10.8337 5.94408C10.8337 7.78512 9.34127 9.27757 7.50023 9.27757C5.65919 9.27757 4.16674 7.78512 4.16674 5.94408C4.16674 4.10305 5.65919 2.6106 7.50023 2.6106C9.34127 2.6106 10.8337 4.10305 10.8337 5.94408Z'
          stroke='#4E4F52'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const NewRedirect = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M12.0004 8.66679V12.6668C12.0004 13.0204 11.8599 13.3595 11.6098 13.6096C11.3598 13.8596 11.0206 14.0001 10.667 14.0001H3.3337C2.98008 14.0001 2.64094 13.8596 2.39089 13.6096C2.14084 13.3595 2.00037 13.0204 2.00037 12.6668V5.33345C2.00037 4.97983 2.14084 4.64069 2.39089 4.39065C2.64094 4.1406 2.98008 4.00012 3.3337 4.00012H7.33369M6.66703 9.33345L14.0004 2.00012M14.0004 2.00012H10.0004M14.0004 2.00012V6.00012'
          stroke='#2E90FA'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const FileUploads = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='28'
        height='28'
        viewBox='0 0 28 28'
        fill='none'
      >
        <rect x='2' y='2' width='24' height='24' rx='12' fill='#E0E1E3' />
        <g clipPath='url(#clip0_148_101548)'>
          <path
            d='M18.1954 17.1955C18.6831 16.9296 19.0684 16.5089 19.2904 15.9997C19.5125 15.4906 19.5586 14.922 19.4216 14.3837C19.2846 13.8454 18.9722 13.3681 18.5338 13.027C18.0954 12.686 17.5558 12.5006 17.0004 12.5003H16.3703C16.219 11.9148 15.9369 11.3714 15.5453 10.9107C15.1537 10.45 14.6627 10.0841 14.1093 9.84043C13.5559 9.5968 12.9545 9.48179 12.3502 9.50406C11.746 9.52632 11.1546 9.68527 10.6207 9.96897C10.0867 10.2527 9.62399 10.6537 9.26733 11.142C8.91067 11.6302 8.66933 12.193 8.56147 12.788C8.45361 13.3829 8.48203 13.9946 8.64459 14.577C8.80716 15.1594 9.09963 15.6973 9.50003 16.1504M14.0002 18.5005V14.0003M14.0002 14.0003L16.0003 15.9997M14.0002 14.0003L12.0001 15.9997'
            stroke='#1C2433'
            strokeWidth='1.00005'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <rect
          x='2'
          y='2'
          width='24'
          height='24'
          rx='12'
          stroke='#ECEDEE'
          strokeWidth='3.6'
        />
        <defs>
          <clipPath id='clip0_148_101548'>
            <rect
              width='12.0006'
              height='12.0006'
              fill='white'
              transform='translate(8 8)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Info = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M10.0005 18.3342C14.6031 18.3342 18.3342 14.6031 18.3342 10.0005C18.3342 5.39788 14.6031 1.66675 10.0005 1.66675C5.39788 1.66675 1.66675 5.39788 1.66675 10.0005C1.66675 14.6031 5.39788 18.3342 10.0005 18.3342Z'
          stroke='#616771'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.0005 13.334V10.0005M10.0005 6.66699H10.0088'
          stroke='#616771'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const Plus = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M3.33374 8.00019H8.00019M12.6666 8.00019H8.00019M8.00019 8.00019V12.6666M8.00019 8.00019V3.33374'
          stroke='currentColor'
          strokeWidth='1.33327'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const CodeIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M5.8335 6.66675L2.42642 9.5287C2.02996 9.86172 2.02996 10.4719 2.42642 10.8049L5.8335 13.6668'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <path
          d='M14.1667 6.66675L17.5738 9.5287C17.9703 9.86172 17.9703 10.4719 17.5738 10.8049L14.1667 13.6668'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
        <path
          d='M11.6669 4.16675L8.3335 15.8336'
          stroke='#4E4F52'
          strokeWidth='1.66669'
          strokeLinecap='round'
        />
      </svg>
    </>
  );
};
export const LinkIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <g clipPath='url(#clip0_448_59548)'>
          <path
            d='M11.6666 9.16669C11.3087 8.68825 10.8521 8.29237 10.3278 8.00591C9.80347 7.71944 9.22367 7.54909 8.62771 7.50641C8.03176 7.46373 7.4336 7.54972 6.8738 7.75854C6.314 7.96736 5.80566 8.29413 5.38326 8.71669L2.88326 11.2167C2.12426 12.0025 1.70429 13.055 1.71378 14.1475C1.72327 15.24 2.16148 16.2851 2.93401 17.0576C3.70655 17.8301 4.7516 18.2683 5.84408 18.2778C6.93657 18.2873 7.98908 17.8674 8.77492 17.1084L10.1999 15.6834M8.33324 10.8333C8.69112 11.3118 9.14771 11.7077 9.67203 11.9941C10.1964 12.2806 10.7762 12.4509 11.3721 12.4936C11.9681 12.5363 12.5662 12.4503 13.126 12.2415C13.6858 12.0327 14.1942 11.7059 14.6166 11.2833L17.1166 8.78335C17.8756 7.9975 18.2955 6.94499 18.2861 5.85251C18.2766 4.76002 17.8384 3.71497 17.0658 2.94243C16.2933 2.1699 15.2482 1.7317 14.1557 1.7222C13.0633 1.71271 12.0108 2.13269 11.2249 2.89168L9.79158 4.31668'
            stroke='#4E4F52'
            strokeWidth='1.66674'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_448_59548'>
            <rect width='20' height='20' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Paypalicon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='81'
        height='16'
        viewBox='0 0 81 40'
        fill='none'
      >
        <g clipPath='url(#clip0_129_83577)'>
          <path
            d='M30.3136 14.3545H25.9013C25.5994 14.3545 25.3426 14.5738 25.2955 14.8719L23.511 26.1861C23.4755 26.4093 23.6484 26.6106 23.8749 26.6106H25.9813C26.2832 26.6106 26.54 26.3913 26.5871 26.0926L27.0684 23.0409C27.1149 22.7422 27.3723 22.5229 27.6736 22.5229H29.0703C31.9768 22.5229 33.6542 21.1164 34.0923 18.3293C34.2897 17.11 34.1007 16.1519 33.5297 15.4809C32.9026 14.7442 31.7903 14.3545 30.3136 14.3545ZM30.8226 18.4868C30.5813 20.07 29.3716 20.07 28.2019 20.07H27.5361L28.0032 17.1132C28.031 16.9345 28.1858 16.8029 28.3665 16.8029H28.6716C29.4684 16.8029 30.22 16.8029 30.6084 17.2571C30.84 17.528 30.911 17.9306 30.8226 18.4868Z'
            fill='#253B80'
          />
          <path
            d='M43.5026 18.435H41.3897C41.2097 18.435 41.0542 18.5667 41.0264 18.7454L40.9329 19.3363L40.7851 19.1221C40.3277 18.4583 39.3077 18.2363 38.2897 18.2363C35.9548 18.2363 33.9606 20.0047 33.5722 22.4854C33.3703 23.7228 33.6574 24.906 34.3593 25.7312C35.0032 26.4899 35.9245 26.806 37.0206 26.806C38.9019 26.806 39.9451 25.5963 39.9451 25.5963L39.8509 26.1834C39.8155 26.4079 39.9884 26.6092 40.2135 26.6092H42.1168C42.4193 26.6092 42.6748 26.3899 42.7226 26.0912L43.8645 18.8596C43.9006 18.637 43.7284 18.435 43.5026 18.435ZM40.5574 22.5473C40.3535 23.7544 39.3955 24.5647 38.1735 24.5647C37.56 24.5647 37.0697 24.3679 36.7548 23.995C36.4426 23.6247 36.3239 23.0976 36.4232 22.5105C36.6135 21.3137 37.5877 20.477 38.791 20.477C39.391 20.477 39.8787 20.6763 40.2 21.0525C40.5219 21.4325 40.6497 21.9628 40.5574 22.5473Z'
            fill='#253B80'
          />
          <path
            d='M54.7554 18.4355H52.6322C52.4296 18.4355 52.2393 18.5362 52.1244 18.7046L49.196 23.0181L47.9548 18.873C47.8767 18.6136 47.6373 18.4355 47.3664 18.4355H45.2799C45.0264 18.4355 44.8502 18.6833 44.9309 18.922L47.2696 25.7852L45.0709 28.8891C44.898 29.1336 45.0722 29.4697 45.3709 29.4697H47.4915C47.6928 29.4697 47.8812 29.3717 47.9954 29.2065L55.0573 19.013C55.2264 18.7691 55.0528 18.4355 54.7554 18.4355Z'
            fill='#253B80'
          />
          <path
            d='M61.7852 14.3545H57.3723C57.071 14.3545 56.8143 14.5738 56.7672 14.8719L54.9827 26.1861C54.9472 26.4093 55.1201 26.6106 55.3452 26.6106H57.6098C57.8201 26.6106 58.0001 26.4571 58.033 26.248L58.5394 23.0409C58.5859 22.7422 58.8433 22.5229 59.1446 22.5229H60.5407C63.4478 22.5229 65.1246 21.1164 65.5633 18.3293C65.7614 17.11 65.571 16.1519 65.0001 15.4809C64.3736 14.7442 63.262 14.3545 61.7852 14.3545ZM62.2943 18.4868C62.0536 20.07 60.844 20.07 59.6736 20.07H59.0085L59.4762 17.1132C59.504 16.9345 59.6575 16.8029 59.8388 16.8029H60.144C60.9401 16.8029 61.6923 16.8029 62.0807 17.2571C62.3123 17.528 62.3827 17.9306 62.2943 18.4868Z'
            fill='#179BD7'
          />
          <path
            d='M74.9734 18.435H72.8618C72.6805 18.435 72.5263 18.5667 72.4992 18.7454L72.4057 19.3363L72.2573 19.1221C71.7999 18.4583 70.7805 18.2363 69.7625 18.2363C67.4276 18.2363 65.4341 20.0047 65.0457 22.4854C64.8444 23.7228 65.1302 24.906 65.8321 25.7312C66.4773 26.4899 67.3973 26.806 68.4934 26.806C70.3747 26.806 71.418 25.5963 71.418 25.5963L71.3238 26.1834C71.2883 26.4079 71.4612 26.6092 71.6876 26.6092H73.5902C73.8915 26.6092 74.1483 26.3899 74.1954 26.0912L75.338 18.8596C75.3728 18.637 75.1999 18.435 74.9734 18.435ZM72.0283 22.5473C71.8257 23.7544 70.8663 24.5647 69.6444 24.5647C69.0321 24.5647 68.5405 24.3679 68.2257 23.995C67.9134 23.6247 67.796 23.0976 67.8941 22.5105C68.0857 21.3137 69.0586 20.477 70.2618 20.477C70.8618 20.477 71.3496 20.6763 71.6709 21.0525C71.9941 21.4325 72.1218 21.9628 72.0283 22.5473Z'
            fill='#179BD7'
          />
          <path
            d='M77.4645 14.6645L75.6536 26.1858C75.6181 26.409 75.791 26.6103 76.0161 26.6103H77.8368C78.1394 26.6103 78.3961 26.3909 78.4426 26.0922L80.2284 14.7787C80.2639 14.5555 80.091 14.3535 79.8658 14.3535H77.8271C77.6471 14.3542 77.4923 14.4858 77.4645 14.6645Z'
            fill='#179BD7'
          />
          <path
            d='M5.1878 28.8095L5.52522 26.6663L4.7736 26.6489H1.18457L3.67876 10.834C3.68651 10.7863 3.71167 10.7418 3.74844 10.7102C3.78522 10.6786 3.83231 10.6611 3.88134 10.6611H9.93296C11.942 10.6611 13.3284 11.0792 14.0523 11.9044C14.3917 12.2915 14.6078 12.696 14.7123 13.1411C14.822 13.6082 14.8239 14.1663 14.7168 14.8469L14.7091 14.8966V15.3327L15.0484 15.525C15.3342 15.6766 15.5613 15.8502 15.7355 16.0489C16.0259 16.3798 16.2136 16.8005 16.293 17.2992C16.3749 17.8121 16.3478 18.4224 16.2136 19.1134C16.0588 19.9082 15.8084 20.6005 15.4704 21.1669C15.1594 21.6889 14.7633 22.1218 14.293 22.4573C13.8439 22.776 13.3104 23.0179 12.7071 23.1727C12.1226 23.325 11.4562 23.4018 10.7252 23.4018H10.2542C9.91747 23.4018 9.59038 23.5231 9.3336 23.7405C9.07618 23.9624 8.90586 24.2656 8.8536 24.5973L8.81812 24.7902L8.22199 28.5676L8.19489 28.7063C8.1878 28.7502 8.17554 28.7721 8.15747 28.7869C8.14134 28.8005 8.11812 28.8095 8.09554 28.8095H5.1878Z'
            fill='#253B80'
          />
          <path
            d='M15.3696 14.9463C15.3516 15.0618 15.3309 15.1798 15.3077 15.3011C14.5096 19.3985 11.7793 20.814 8.29222 20.814H6.51673C6.09028 20.814 5.73093 21.1237 5.66447 21.5444L4.75544 27.3095L4.49802 28.9437C4.4548 29.2198 4.6677 29.4689 4.94641 29.4689H8.09544C8.46835 29.4689 8.78512 29.1979 8.84383 28.8302L8.8748 28.6702L9.4677 24.9076L9.50576 24.7011C9.56383 24.3321 9.88125 24.0611 10.2542 24.0611H10.7251C13.7761 24.0611 16.1645 22.8224 16.8625 19.2379C17.1542 17.7405 17.0032 16.4902 16.2316 15.6108C15.998 15.3456 15.7083 15.1256 15.3696 14.9463Z'
            fill='#179BD7'
          />
          <path
            d='M14.5349 14.6136C14.4129 14.5781 14.2871 14.5459 14.1581 14.5168C14.0284 14.4884 13.8955 14.4633 13.7587 14.4413C13.28 14.3639 12.7555 14.3271 12.1936 14.3271H7.45036C7.33358 14.3271 7.22262 14.3536 7.12326 14.4013C6.90455 14.5065 6.74197 14.7136 6.70262 14.9671L5.69358 21.3581L5.66455 21.5446C5.731 21.1239 6.09036 20.8142 6.51681 20.8142H8.29229C11.7794 20.8142 14.5097 19.3981 15.3078 15.3013C15.3316 15.1801 15.3516 15.062 15.3697 14.9465C15.1678 14.8394 14.9491 14.7478 14.7136 14.6697C14.6555 14.6504 14.5955 14.6317 14.5349 14.6136Z'
            fill='#222D65'
          />
          <path
            d='M6.70257 14.9671C6.74193 14.7135 6.90451 14.5065 7.12322 14.4019C7.22322 14.3542 7.33354 14.3277 7.45031 14.3277H12.1935C12.7555 14.3277 13.28 14.3645 13.7587 14.4419C13.8955 14.4639 14.0284 14.489 14.1581 14.5174C14.2871 14.5465 14.4129 14.5787 14.5348 14.6142C14.5955 14.6323 14.6555 14.651 14.7142 14.6697C14.9497 14.7477 15.1684 14.84 15.3703 14.9465C15.6077 13.4323 15.3684 12.4013 14.5497 11.4677C13.6471 10.44 12.0181 10 9.93354 10H3.88193C3.45612 10 3.0929 10.3097 3.02709 10.731L0.506444 26.7084C0.456767 27.0245 0.700638 27.3097 1.01935 27.3097H4.75548L5.69354 21.3581L6.70257 14.9671Z'
            fill='#253B80'
          />
        </g>
        <defs>
          <clipPath id='clip0_129_83577'>
            <rect
              width='80'
              height='40'
              fill='white'
              transform='translate(0.5)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const AmzonPayicon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='80'
        height='16'
        viewBox='0 0 80 16'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M31.5677 12.6579C28.6114 14.8397 24.3253 16 20.6343 16C15.4617 16 10.8035 14.0878 7.27834 10.9049C7.00188 10.6547 7.24843 10.3134 7.58109 10.5069C11.3841 12.72 16.0876 14.0529 20.9447 14.0529C24.2215 14.0529 27.8237 13.3726 31.1381 11.9668C31.638 11.7551 32.0572 12.2962 31.5677 12.6579Z'
          fill='#F79C34'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M32.7981 11.2535C32.4197 10.7695 30.2986 11.0242 29.3455 11.1384C29.0568 11.1733 29.0119 10.9209 29.2721 10.7382C30.9644 9.54941 33.7376 9.8925 34.0599 10.2909C34.3844 10.692 33.9742 13.4725 32.3889 14.799C32.1446 15.003 31.9125 14.8942 32.0208 14.625C32.378 13.7335 33.1766 11.7385 32.7981 11.2535Z'
          fill='#F79C34'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M29.4126 2.34089V1.18609C29.4135 1.01024 29.5458 0.893311 29.7054 0.893764L34.882 0.893311C35.0475 0.893311 35.1807 1.01341 35.1807 1.18473V2.17501C35.1789 2.34135 35.0389 2.55798 34.791 2.90198L32.1093 6.73077C33.1045 6.70766 34.1574 6.85677 35.062 7.36483C35.2659 7.47949 35.3208 7.64945 35.3366 7.81578V9.04808C35.3366 9.21804 35.1508 9.41429 34.955 9.31231C33.362 8.47748 31.2477 8.38638 29.4856 9.32228C29.3056 9.41836 29.1176 9.22439 29.1176 9.05443V7.88286C29.1176 7.69568 29.1212 7.3748 29.3102 7.08927L32.4165 2.63231L29.7117 2.63186C29.5463 2.63186 29.4135 2.51402 29.4126 2.34089Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.5297 9.55448H8.95475C8.80474 9.54496 8.68509 9.43256 8.67285 9.28844L8.67421 1.20527C8.67421 1.04393 8.81018 0.91476 8.97832 0.91476L10.4449 0.914307C10.5981 0.922012 10.7214 1.03804 10.7309 1.18579V2.24088H10.7608C11.1429 1.22023 11.8631 0.743896 12.8334 0.743896C13.8183 0.743896 14.436 1.22023 14.877 2.24088C15.259 1.22023 16.1265 0.743896 17.0524 0.743896C17.7141 0.743896 18.4343 1.01628 18.8753 1.62858C19.3752 2.30932 19.2727 3.29552 19.2727 4.16298L19.2709 9.26397C19.2709 9.42486 19.1354 9.55448 18.9673 9.55448H17.3946C17.236 9.54451 17.1118 9.41942 17.1118 9.26442L17.1113 4.97923C17.1113 4.63932 17.1408 3.78908 17.0669 3.46593C16.9495 2.92116 16.5969 2.76797 16.1415 2.76797C15.7589 2.76797 15.3619 3.02314 15.2001 3.43103C15.0383 3.83984 15.0533 4.51967 15.0533 4.97923V9.26397C15.0533 9.42486 14.9173 9.55448 14.7496 9.55448H13.1765C13.0183 9.54451 12.8937 9.41942 12.8937 9.26442L12.8919 4.97923C12.8919 4.07778 13.0392 2.75166 11.922 2.75166C10.7898 2.75166 10.8343 4.04379 10.8343 4.97923L10.8333 9.26397C10.8333 9.42486 10.6974 9.55448 10.5297 9.55448Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M39.6513 2.39407C38.4902 2.39407 38.4167 3.97535 38.4167 4.96201C38.4167 5.94867 38.4022 8.05795 39.6373 8.05795C40.8573 8.05795 40.9162 6.35702 40.9162 5.3196C40.9162 4.63932 40.8863 3.82261 40.6806 3.17632C40.5043 2.61479 40.1512 2.39407 39.6513 2.39407ZM39.6373 0.743896C41.9745 0.743896 43.2385 2.75166 43.2385 5.30283C43.2385 7.76834 41.8422 9.72489 39.6373 9.72489C37.3435 9.72489 36.094 7.71758 36.094 5.21762C36.094 2.69999 37.358 0.743896 39.6373 0.743896Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M46.2701 9.55448H44.7006C44.5433 9.54451 44.4182 9.41942 44.4182 9.26442L44.4155 1.17853C44.4291 1.03033 44.5597 0.91476 44.7183 0.91476L46.179 0.914307C46.3168 0.921558 46.4301 1.01492 46.4591 1.14046V2.37685H46.4886C46.93 1.27099 47.5468 0.743896 48.6345 0.743896C49.3402 0.743896 50.0314 0.999059 50.4723 1.69656C50.8839 2.34285 50.8839 3.43103 50.8839 4.21374V9.30022C50.8667 9.44344 50.7379 9.55448 50.582 9.55448H49.0035C48.8575 9.54542 48.7401 9.438 48.7229 9.30022V4.9117C48.7229 4.02702 48.8263 2.73398 47.7381 2.73398C47.356 2.73398 47.003 2.98914 46.8267 3.38027C46.6059 3.87383 46.5765 4.36693 46.5765 4.9117V9.26397C46.5738 9.42486 46.4378 9.55448 46.2701 9.55448Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M26.8732 9.53489C26.7694 9.62825 26.6194 9.6346 26.5015 9.5716C25.9785 9.13696 25.8847 8.93619 25.5987 8.52194C24.7344 9.40255 24.1221 9.66678 23.0022 9.66678C21.6765 9.66678 20.645 8.84826 20.645 7.21214C20.645 5.93361 21.338 5.06434 22.3247 4.63831C23.179 4.26304 24.3723 4.19506 25.286 4.09263V3.88823C25.286 3.51251 25.3154 3.07017 25.0943 2.74612C24.9026 2.45606 24.5345 2.33686 24.2105 2.33686C23.6095 2.33686 23.0761 2.6446 22.9447 3.28228C22.917 3.42413 22.8137 3.56509 22.6714 3.57234L21.1445 3.40691C21.0158 3.37745 20.8725 3.27412 20.9092 3.07742C21.256 1.2514 22.8866 0.682158 24.3687 0.666748H24.4856C25.2443 0.676266 26.2133 0.884293 26.8034 1.45036C27.5698 2.16645 27.4954 3.12093 27.4954 4.16107V6.61435C27.4954 7.35264 27.8023 7.67624 28.0901 8.07371C28.1911 8.21738 28.2133 8.38734 28.0851 8.49249C27.7633 8.76215 27.1918 9.25843 26.8777 9.53852L26.8732 9.53489ZM25.286 5.69522C25.286 6.30888 25.3005 6.82011 24.9914 7.36578C24.7408 7.80858 24.3428 8.08142 23.9009 8.08142C23.2973 8.08142 22.9437 7.6214 22.9437 6.9393C22.9437 5.59777 24.1466 5.35394 25.286 5.35394V5.69522Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.22859 9.53489C6.12435 9.62825 5.97388 9.6346 5.8565 9.5716C5.33303 9.13696 5.23921 8.93619 4.95369 8.52194C4.08894 9.40255 3.4771 9.66678 2.35719 9.66678C1.03153 9.66678 0 8.84826 0 7.21214C0 5.93361 0.692066 5.06434 1.67963 4.63831C2.53395 4.26304 3.72728 4.19506 4.64051 4.09263V3.88823C4.64051 3.51251 4.67042 3.07017 4.44925 2.74612C4.25754 2.45606 3.88907 2.33686 3.56548 2.33686C2.96451 2.33686 2.43016 2.6446 2.29963 3.28228C2.27244 3.42413 2.16865 3.56509 2.02589 3.57234L0.499448 3.40691C0.37028 3.37745 0.227063 3.27412 0.264227 3.07742C0.610033 1.2514 2.24117 0.682158 3.72365 0.666748H3.84058C4.59927 0.676266 5.56825 0.884293 6.15834 1.45036C6.92428 2.16645 6.85041 3.12093 6.85041 4.16107V6.61434C6.85041 7.35264 7.15724 7.67624 7.44503 8.07371C7.54519 8.21738 7.56831 8.38734 7.44005 8.49249C7.11826 8.76215 6.5463 9.25843 6.23222 9.53852L6.22859 9.53489ZM4.64051 5.69522C4.64051 6.30888 4.65547 6.82011 4.34592 7.36578C4.09574 7.80858 3.69782 8.08142 3.25547 8.08142C2.65179 8.08142 2.29827 7.6214 2.29827 6.9393C2.29827 5.59777 3.50157 5.35394 4.64051 5.35394V5.69522Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M72.4122 12.4542C72.4122 12.2493 72.4122 12.0653 72.4122 11.8605C72.4122 11.6914 72.4951 11.5749 72.6714 11.5854C73.0005 11.632 73.4659 11.6787 73.7963 11.6107C74.2278 11.521 74.5373 11.2151 74.7204 10.7958C74.9783 10.2058 75.1492 9.72987 75.257 9.4176L71.9807 1.30135C71.9254 1.16357 71.9091 0.907959 72.1842 0.907959H73.3295C73.5479 0.907959 73.6368 1.04664 73.6857 1.18261L76.061 7.77514L78.3285 1.18261C78.3747 1.04755 78.4676 0.907959 78.6843 0.907959H79.7643C80.0376 0.907959 80.0222 1.16312 79.9678 1.30135L76.7178 9.67095C76.2972 10.785 75.737 12.5593 74.4752 12.8675C73.8425 13.0329 73.0444 12.9731 72.5758 12.7769C72.4575 12.7175 72.4122 12.5589 72.4122 12.4542Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M70.8845 9.06029C70.8845 9.21121 70.7607 9.33494 70.6089 9.33494H69.8013C69.6268 9.33494 69.5076 9.20895 69.4854 9.06029L69.4043 8.51054C69.0331 8.82462 68.5776 9.10063 68.0836 9.29279C67.1336 9.66171 66.0386 9.7229 65.1105 9.15275C64.4392 8.74077 64.083 7.9354 64.083 7.10465C64.083 6.46199 64.2811 5.82476 64.7202 5.36202C65.3062 4.72978 66.1556 4.41933 67.1812 4.41933C67.8008 4.41933 68.6873 4.4923 69.3322 4.70304V3.59674C69.3322 2.47184 68.8586 1.98509 67.61 1.98509C66.6555 1.98509 65.9253 2.12921 64.9092 2.44511C64.7465 2.45054 64.6513 2.32681 64.6513 2.17589V1.54501C64.6513 1.39364 64.7805 1.24725 64.9206 1.20283C65.6462 0.886484 66.6741 0.689334 67.7668 0.653076C69.1912 0.653076 70.8845 0.974409 70.8845 3.16527V9.06029ZM69.3322 7.44502V5.77581C68.7901 5.62761 67.8932 5.56597 67.5461 5.56597C66.9977 5.56597 66.3971 5.69559 66.0835 6.03324C65.8492 6.2807 65.7431 6.63602 65.7431 6.97956C65.7431 7.42372 65.8968 7.86923 66.2557 8.0895C66.6727 8.37276 67.3194 8.33831 67.9272 8.16564C68.5114 7.99976 69.0598 7.70653 69.3322 7.44502Z'
          fill='#333E47'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M58.9761 2.00991C60.7681 2.00991 61.2562 3.41897 61.2562 5.03243C61.2662 6.12016 61.0663 7.09005 60.503 7.64524C60.0815 8.06084 59.6106 8.17415 58.9018 8.17415C58.2709 8.17415 57.441 7.84511 56.821 7.38691V2.77359C57.4664 2.27776 58.2899 2.00991 58.9761 2.00991ZM56.5464 12.744H55.4646C55.3132 12.744 55.1895 12.6202 55.1895 12.4693C55.1895 8.71212 55.1895 4.95448 55.1895 1.19729C55.1895 1.04637 55.3132 0.922639 55.4646 0.922639H56.2926C56.4666 0.922639 56.5858 1.04863 56.608 1.19729L56.695 1.78783C57.4705 1.09939 58.4689 0.657959 59.4203 0.657959C62.0847 0.657959 62.9608 2.85335 62.9608 5.13622C62.9608 7.57862 61.6206 9.54106 59.3541 9.54106C58.3996 9.54106 57.5072 9.18891 56.821 8.57706V12.4693C56.821 12.6202 56.6973 12.744 56.5464 12.744Z'
          fill='#333E47'
        />
      </svg>
    </>
  );
};
export const TripeIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='65'
        height='27'
        viewBox='0 0 65 27'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M64.4998 14.0885C64.4998 9.53741 62.2954 5.94629 58.082 5.94629C53.8509 5.94629 51.2909 9.53741 51.2909 14.053C51.2909 19.4041 54.3131 22.1063 58.6509 22.1063C60.7665 22.1063 62.3665 21.6263 63.5754 20.9508V17.3952C62.3665 17.9997 60.9798 18.373 59.2198 18.373C57.4954 18.373 55.9665 17.7686 55.7709 15.6708H64.4643C64.4643 15.4397 64.4998 14.5152 64.4998 14.0885ZM55.7176 12.3996C55.7176 10.3907 56.9442 9.55519 58.0642 9.55519C59.1487 9.55519 60.3043 10.3907 60.3043 12.3996H55.7176Z'
          fill='#635BFF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M44.4289 5.94629C42.6867 5.94629 41.5667 6.76407 40.9445 7.33296L40.7134 6.23073H36.8022V26.9597L41.2467 26.0175L41.2645 20.9863C41.9045 21.4486 42.8467 22.1063 44.4112 22.1063C47.5934 22.1063 50.4912 19.5463 50.4912 13.9108C50.4734 8.75519 47.5401 5.94629 44.4289 5.94629ZM43.3623 18.1952C42.3134 18.1952 41.6911 17.8219 41.2645 17.3597L41.2467 10.7641C41.7089 10.2485 42.3489 9.89297 43.3623 9.89297C44.9801 9.89297 46.1001 11.7063 46.1001 14.0352C46.1001 16.4174 44.9978 18.1952 43.3623 18.1952Z'
          fill='#635BFF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.6865 4.89801L35.1488 3.938V0.329102L30.6865 1.27133V4.89801Z'
          fill='#635BFF'
        />
        <path
          d='M35.1488 6.24854H30.6865V21.8041H35.1488V6.24854Z'
          fill='#635BFF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.9044 7.565L25.6199 6.24944H21.7799V21.805H26.2244V11.2628C27.2733 9.89389 29.051 10.1428 29.6022 10.3383V6.24944C29.0333 6.0361 26.9533 5.64499 25.9044 7.565Z'
          fill='#635BFF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.0154 2.3916L12.6776 3.31605L12.6598 17.5561C12.6598 20.1872 14.6331 22.125 17.2643 22.125C18.722 22.125 19.7887 21.8583 20.3754 21.5383V17.9294C19.8065 18.1605 16.9976 18.9783 16.9976 16.3472V10.0361H20.3754V6.24939H16.9976L17.0154 2.3916Z'
          fill='#635BFF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.99755 10.7641C4.99755 10.0707 5.56644 9.80408 6.50867 9.80408C7.85978 9.80408 9.56645 10.213 10.9176 10.9419V6.76407C9.44201 6.1774 7.98423 5.94629 6.50867 5.94629C2.89976 5.94629 0.499756 7.83074 0.499756 10.9774C0.499756 15.8841 7.25533 15.1019 7.25533 17.2174C7.25533 18.0352 6.54422 18.3019 5.54866 18.3019C4.0731 18.3019 2.18865 17.6974 0.695312 16.8797V21.1108C2.34865 21.8219 4.01977 22.1241 5.54866 22.1241C9.24645 22.1241 11.7887 20.293 11.7887 17.1108C11.7709 11.813 4.99755 12.7552 4.99755 10.7641Z'
          fill='#635BFF'
        />
      </svg>
    </>
  );
};
export const Razorpay = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='80'
        height='17'
        viewBox='0 0 80 17'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0685 6.39574C18.9423 6.86671 18.6978 7.21238 18.3349 7.43308C17.9716 7.65375 17.462 7.76432 16.8047 7.76432H14.7164L15.4495 5.02737H17.5378C18.1946 5.02737 18.6455 5.13773 18.8905 5.35839C19.135 5.57931 19.1947 5.92503 19.0685 6.39574ZM21.2311 6.33676C21.4966 5.34641 21.3866 4.58604 20.901 4.05635C20.4153 3.52666 19.5644 3.26196 18.3491 3.26196H13.6875L10.8818 13.7376H13.1466L14.2778 9.51487H15.763C16.0961 9.51487 16.3582 9.5689 16.5499 9.67681C16.7421 9.78493 16.8546 9.97625 16.8893 10.2505L17.2933 13.7376H19.7199L19.3262 10.4861C19.246 9.76023 18.914 9.33355 18.3305 9.2061C19.0744 8.99054 19.6974 8.63212 20.1992 8.13181C20.7005 7.63176 21.0447 7.03355 21.2311 6.33676Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M26.7353 9.98575C26.5461 10.6918 26.2545 11.2315 25.8609 11.6041C25.4667 11.977 24.9953 12.1632 24.4466 12.1632C23.8871 12.1632 23.5076 11.9794 23.3075 11.6115C23.1065 11.2438 23.0997 10.7119 23.2865 10.0151C23.4728 9.31881 23.7702 8.77447 24.1795 8.38177C24.5883 7.98983 25.0671 7.7934 25.6163 7.7934C26.165 7.7934 26.5367 7.98253 26.7294 8.36003C26.9221 8.73753 26.9245 9.27942 26.7353 9.98575ZM27.728 6.278L27.4444 7.33738C27.3216 6.95473 27.0844 6.65085 26.7333 6.42529C26.3817 6.19973 25.946 6.08667 25.4266 6.08667C24.7893 6.08667 24.1766 6.2511 23.5888 6.57968C23.0009 6.90846 22.4869 7.37187 22.0473 7.97003C21.6076 8.56845 21.2853 9.25008 21.0804 10.0151C20.8755 10.7804 20.8344 11.4547 20.9577 12.0381C21.0809 12.6219 21.3479 13.0706 21.7592 13.3845C22.17 13.6986 22.6992 13.8552 23.3462 13.8552C23.8655 13.8552 24.3605 13.7473 24.83 13.5315C25.2994 13.316 25.698 13.0166 26.0261 12.6341L25.7303 13.7375H27.9212L29.919 6.278H27.728Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M37.7972 6.27832H31.4298L30.9847 7.94102H34.6902L29.7909 12.1782L29.3728 13.7379H35.9461L36.3916 12.0754H32.4216L37.3952 7.77903L37.7972 6.27832Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M43.4031 9.97106C43.206 10.7065 42.914 11.2562 42.5277 11.6191C42.1414 11.9819 41.6738 12.1632 41.1251 12.1632C39.9778 12.1632 39.6002 11.4328 39.9915 9.97106C40.1862 9.24514 40.4796 8.69835 40.8718 8.33065C41.2645 7.96269 41.7399 7.77871 42.2989 7.77871C42.8475 7.77871 43.2178 7.96269 43.4085 8.33065C43.5992 8.69835 43.5978 9.24514 43.4031 9.97106ZM44.6849 6.55738C44.1807 6.24372 43.5366 6.08667 42.7522 6.08667C41.958 6.08667 41.2224 6.24372 40.5451 6.55738C39.8678 6.87152 39.2912 7.32269 38.8154 7.91106C38.339 8.49968 37.9957 9.18621 37.7854 9.97106C37.5751 10.7559 37.5507 11.4422 37.7121 12.0308C37.8729 12.6194 38.2075 13.0706 38.717 13.3845C39.2262 13.6986 39.8775 13.8552 40.6718 13.8552C41.4562 13.8552 42.1844 13.6986 42.8569 13.3845C43.5283 13.0706 44.1029 12.6194 44.5793 12.0308C45.0551 11.4422 45.3984 10.7559 45.6087 9.97106C45.819 9.18621 45.8435 8.49968 45.6826 7.91106C45.5212 7.32269 45.1886 6.87152 44.6849 6.55738Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M67.6007 9.98575C67.4115 10.6918 67.1199 11.2315 66.7263 11.6041C66.3325 11.977 65.8601 12.1632 65.3115 12.1632C64.753 12.1632 64.373 11.9794 64.1729 11.6115C63.9719 11.2438 63.9651 10.7119 64.1519 10.0151C64.3382 9.31881 64.6356 8.77447 65.0449 8.38177C65.4537 7.98983 65.9325 7.7934 66.4817 7.7934C67.0304 7.7934 67.4021 7.98253 67.5948 8.36003C67.7875 8.73753 67.7899 9.27942 67.6007 9.98575ZM68.5934 6.278L68.3098 7.33738C68.187 6.95473 67.9498 6.65085 67.5987 6.42529C67.2471 6.19973 66.8114 6.08667 66.292 6.08667C65.6547 6.08667 65.042 6.2511 64.4542 6.57968C63.8663 6.90846 63.3523 7.37187 62.9127 7.97003C62.473 8.56845 62.1507 9.25008 61.9458 10.0151C61.7409 10.7804 61.7003 11.4547 61.8231 12.0381C61.9463 12.6219 62.2128 13.0706 62.6246 13.3845C63.0354 13.6986 63.5646 13.8552 64.2116 13.8552C64.7309 13.8552 65.2259 13.7473 65.6953 13.5315C66.1648 13.316 66.5634 13.0166 66.8915 12.6341L66.5957 13.7375H68.7866L70.7844 6.278H68.5934Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M52.4964 8.27897L53.0549 6.24857C52.8651 6.15046 52.6137 6.10132 52.3003 6.10132C51.8 6.10132 51.3183 6.22632 50.8542 6.47658C50.4556 6.69129 50.1162 6.99268 49.8296 7.37031L50.1201 6.2769L49.4858 6.27795H47.9299L45.9167 13.7374H48.138L49.1821 9.83867C49.3342 9.26984 49.6071 8.82602 50.0018 8.50724C50.3954 8.18846 50.8869 8.02893 51.4753 8.02893C51.8381 8.02893 52.178 8.11235 52.4964 8.27897Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M58.6792 10.0151C58.4924 10.7119 58.2029 11.2438 57.8107 11.6115C57.4175 11.9794 56.947 12.1631 56.3983 12.1631C55.8491 12.1631 55.475 11.977 55.2759 11.6041C55.0764 11.2315 55.0715 10.692 55.2608 9.9857C55.45 9.27941 55.7444 8.73748 56.1445 8.35998C56.5445 7.98248 57.0194 7.79335 57.5686 7.79335C58.1075 7.79335 58.4738 7.98983 58.668 8.38202C58.8616 8.77442 58.8656 9.31901 58.6792 10.0151ZM60.2315 6.57962C59.8192 6.25105 59.2945 6.08691 58.6577 6.08691C58.0987 6.08691 57.5667 6.21437 57.0629 6.46931C56.5578 6.72472 56.1484 7.07238 55.8344 7.51396L55.8415 7.46503L56.2147 6.27693H55.7853V6.27799H54.0465L53.4943 8.34077C53.488 8.36475 53.4826 8.38713 53.4762 8.41136L51.1987 16.9156H53.4195L54.5663 12.6344C54.6788 13.0165 54.9126 13.316 55.2667 13.5315C55.6207 13.7473 56.0574 13.8552 56.5773 13.8552C57.2243 13.8552 57.8395 13.6986 58.4239 13.3845C59.0079 13.0708 59.5155 12.6219 59.9459 12.0381C60.3767 11.4549 60.6946 10.7803 60.8995 10.0151C61.1045 9.25003 61.147 8.56845 61.0281 7.97003C60.9093 7.37182 60.6432 6.90845 60.2315 6.57962Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M79.9805 6.28039L79.982 6.27832H78.6368C78.5938 6.27832 78.5559 6.27954 78.5166 6.28039H77.8184L77.4614 6.77804C77.4328 6.81553 77.4042 6.85327 77.3734 6.89705L77.3345 6.95467L74.4973 10.9082L73.909 6.27832H71.585L72.7619 13.3136L70.1628 16.9159H70.2369H71.5639H72.4782L73.1081 16.0232C73.1267 15.9966 73.1426 15.9748 73.1624 15.9467L73.8974 14.9041L73.9185 14.8742L77.2073 10.2096L79.9783 6.28347L79.982 6.28039H79.9805Z'
          fill='#072654'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.17458 4.46203L4.50977 6.90987L8.31382 4.44826L5.82609 13.7352L8.35238 13.7376L12.0274 0.0205078L5.17458 4.46203Z'
          fill='#3395FF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.08004 9.83332L0.0341797 13.7374H5.21249C5.21249 13.7374 7.33055 5.7972 7.33114 5.79492C7.32916 5.79619 1.08004 9.83332 1.08004 9.83332Z'
          fill='#072654'
        />
      </svg>
    </>
  );
};
export const RightArrows = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M4.16589 10.0005H15.8331M15.8331 10.0005L9.9995 4.16687M15.8331 10.0005L9.9995 15.8341'
          stroke='#1C2433'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const BellIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M11.4417 17.4998C11.2951 17.7524 11.0849 17.962 10.8318 18.1078C10.5788 18.2535 10.292 18.3302 9.99999 18.3302C9.70801 18.3302 9.42115 18.2535 9.16814 18.1078C8.91512 17.962 8.70483 17.7524 8.55832 17.4998M15 6.6665C15 5.34042 14.4732 4.06865 13.5355 3.13097C12.5979 2.19329 11.3261 1.6665 10 1.6665C8.67392 1.6665 7.40215 2.19329 6.46447 3.13097C5.52678 4.06865 5 5.34042 5 6.6665C5 12.4998 2.5 14.1665 2.5 14.1665H17.5C17.5 14.1665 15 12.4998 15 6.6665Z'
          stroke='#1C2433'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const CrossIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M4.99902 5L14.9995 15.0005M14.9995 5L4.99902 15.0005'
          stroke='#1C2433'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};

export const MenuIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M2.5 5H17.5M2.5 10H17.5M2.5 15H17.5'
          stroke='#1C2433'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};

export const ThreeDotsVertical = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <circle cx='12' cy='12' r='1'></circle>
        <circle cx='12' cy='5' r='1'></circle>
        <circle cx='12' cy='19' r='1'></circle>
      </svg>
    </>
  );
};
export const PencilEdit = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <g clipPath='url(#clip0_790_55700)'>
          <path
            d='M14.1667 2.50106C14.3856 2.28219 14.6455 2.10857 14.9314 1.99012C15.2174 1.87167 15.5239 1.8107 15.8334 1.8107C16.1429 1.8107 16.4494 1.87167 16.7354 1.99012C17.0214 2.10857 17.2812 2.28219 17.5001 2.50106C17.719 2.71993 17.8926 2.97976 18.011 3.26573C18.1295 3.5517 18.1904 3.85819 18.1904 4.16772C18.1904 4.47725 18.1295 4.78375 18.011 5.06972C17.8926 5.35568 17.719 5.61552 17.5001 5.83439L6.25008 17.0844L1.66675 18.3344L2.91675 13.7511L14.1667 2.50106Z'
            stroke='currentColor'
            strokeWidth='1.66674'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_790_55700'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(0 0.000915527)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Delete = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <g clipPath='url(#clip0_790_55703)'>
          <path
            d='M2.5 5.00091H4.16667M4.16667 5.00091H17.5M4.16667 5.00091V16.6676C4.16667 17.1096 4.34226 17.5335 4.65482 17.8461C4.96738 18.1586 5.39131 18.3342 5.83333 18.3342H14.1667C14.6087 18.3342 15.0326 18.1586 15.3452 17.8461C15.6577 17.5335 15.8333 17.1096 15.8333 16.6676V5.00091H4.16667ZM6.66667 5.00091V3.33424C6.66667 2.89221 6.84226 2.46829 7.15482 2.15573C7.46738 1.84317 7.89131 1.66757 8.33333 1.66757H11.6667C12.1087 1.66757 12.5326 1.84317 12.8452 2.15573C13.1577 2.46829 13.3333 2.89221 13.3333 3.33424V5.00091'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8.33334 9.16757V14.1676M11.6667 9.16757V14.1676'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_790_55703'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(0 0.000915527)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const DragIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 4C8.55228 4 9 3.55228 9 3C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3C7 3.55228 7.44772 4 8 4Z'
        stroke='#1c2433'
        strokeWidth='2'
        stroke-miterlimit='16'
        strokeLinecap='round'
      ></path>
      <path
        d='M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z'
        stroke='#1c2433'
        strokeWidth='2'
        stroke-miterlimit='16'
        strokeLinecap='round'
      ></path>
      <path
        d='M8 22C8.55228 22 9 21.5523 9 21C9 20.4477 8.55228 20 8 20C7.44772 20 7 20.4477 7 21C7 21.5523 7.44772 22 8 22Z'
        stroke='#1c2433'
        strokeWidth='2'
        stroke-miterlimit='16'
        strokeLinecap='round'
      ></path>
      <path
        d='M16 4C16.5523 4 17 3.55228 17 3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3C15 3.55228 15.4477 4 16 4Z'
        stroke='#1c2433'
        strokeWidth='2'
        stroke-miterlimit='16'
        strokeLinecap='round'
      ></path>
      <path
        d='M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z'
        stroke='#1c2433'
        strokeWidth='2'
        stroke-miterlimit='16'
        strokeLinecap='round'
      ></path>
      <path
        d='M16 22C16.5523 22 17 21.5523 17 21C17 20.4477 16.5523 20 16 20C15.4477 20 15 20.4477 15 21C15 21.5523 15.4477 22 16 22Z'
        stroke='#1c2433'
        strokeWidth='2'
        stroke-miterlimit='16'
        strokeLinecap='round'
      ></path>
    </svg>
  );
};

export const DeleteProductIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='feather feather-trash-2'
    >
      <polyline points='3 6 5 6 21 6'></polyline>
      <path d='M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2'></path>
      <line x1='10' y1='11' x2='10' y2='17'></line>
      <line x1='14' y1='11' x2='14' y2='17'></line>
    </svg>
  );
};
export const Chevronup = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='12'
        height='8'
        viewBox='0 0 12 8'
        fill='none'
      >
        <path
          d='M11.0007 6.66675L6.00048 1.66651L1.00024 6.66675'
          stroke='currentcolor'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const Chevrondown = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='12'
        height='8'
        viewBox='0 0 12 8'
        fill='none'
      >
        <path
          d='M1.00024 1.33375L6.00048 6.33398L11.0007 1.33375'
          stroke='currentcolor'
          strokeWidth='1.66674'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const Chevronright = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          d='M7.5 15.0029L12.5 10.0029L7.5 5.00287'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const Upgrows = () => {
  return (
    <>
      <svg
        style={{ display: 'flex' }}
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='12'
        viewBox='0 0 20 12'
        fill='none'
      >
        <path
          d='M19.1667 1.00098L11.25 8.91764L7.08337 4.75098L0.833374 11.001M19.1667 1.00098H14.1667M19.1667 1.00098V6.00098'
          stroke='#027A48'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export const Downgrows = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
      >
        <g clipPath='url(#clip0_515_57267)'>
          <path
            d='M14.1666 15.0018H19.1666M19.1666 15.0018V10.0018M19.1666 15.0018L11.25 7.08516L7.08331 11.2518L0.833313 5.00183'
            stroke='#DF5146'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_515_57267'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(0 0.00183105)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Avatarmedium = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='46'
        height='46'
        viewBox='0 0 46 46'
        fill='none'
      >
        <g clipPath='url(#clip0_1053_81749)'>
          <g clipPath='url(#clip1_1053_81749)'>
            <rect x='3' y='3' width='40' height='40' rx='20' fill='#F0EDFA' />
            <path
              d='M23 24.3333C26.5899 24.3333 29.5 21.4232 29.5 17.8333C29.5 14.2435 26.5899 11.3333 23 11.3333C19.4102 11.3333 16.5 14.2435 16.5 17.8333C16.5 21.4232 19.4102 24.3333 23 24.3333Z'
              fill='#413BBC'
            />
            <path
              d='M7.83337 43.8333C7.83337 35.457 14.6237 28.6667 23 28.6667C31.3764 28.6667 38.1667 35.457 38.1667 43.8333H7.83337Z'
              fill='#413BBC'
            />
          </g>
          <rect
            x='2.375'
            y='2.375'
            width='41.25'
            height='41.25'
            rx='20.625'
            stroke='white'
            strokeWidth='1.25'
          />
        </g>
        <rect
          x='1.95833'
          y='1.95833'
          width='42.0833'
          height='42.0833'
          rx='21.0417'
          stroke='white'
          strokeWidth='2.08333'
        />
        <defs>
          <clipPath id='clip0_1053_81749'>
            <rect x='3' y='3' width='40' height='40' rx='20' fill='white' />
          </clipPath>
          <clipPath id='clip1_1053_81749'>
            <rect x='3' y='3' width='40' height='40' rx='20' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const EyeOff = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_923_52448)'>
        <path
          d='M14.12 15.0565C13.8454 15.3513 13.5141 15.5877 13.1462 15.7516C12.7782 15.9156 12.3809 16.0038 11.9781 16.0109C11.5753 16.018 11.1752 15.9439 10.8016 15.793C10.4281 15.6421 10.0887 15.4176 9.80385 15.1327C9.51897 14.8478 9.29439 14.5085 9.14351 14.1349C8.99262 13.7614 8.91853 13.3612 8.92563 12.9584C8.93274 12.5556 9.02091 12.1584 9.18488 11.7904C9.34884 11.4224 9.58525 11.0912 9.88 10.8165M1 1.93652L23 23.9365M10 4.9364C16.5 4.43813 21 8.92254 23 12.9087C22.4515 14.0769 22.0082 14.7327 21 15.8983M17.94 18.8765C16.2306 20.1795 14.1491 20.9014 12 20.9365C7.91111 20.9365 4.84583 18.2069 3.00348 15.9365C1.6918 14.3201 1 12.9365 1 12.9365C1.57034 11.8736 2.24189 10.8723 3.00348 9.94563C3.90287 8.85129 4.92783 7.86106 6.06 6.99653L17.94 18.8765Z'
          stroke='#1c2433'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        ></path>
      </g>
      <defs>
        <clipPath id='clip0_923_52448'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(0 0.936523)'
          ></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export const Eye = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 4.93652C5 4.93652 1 12.9365 1 12.9365C1 12.9365 5 20.9365 12 20.9365C19 20.9365 23 12.9365 23 12.9365C23 12.9365 19 4.93652 12 4.93652Z'
        stroke='#1c2433'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
    </svg>
  );
};

export const Download = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 15.9365V3.93652M12 15.9365L7 10.9365M12 15.9365L17 10.9365M21 15.9365V19.9365C21 20.467 20.7893 20.9757 20.4142 21.3507C20.0391 21.7258 19.5304 21.9365 19 21.9365H5C4.46957 21.9365 3.96086 21.7258 3.58579 21.3507C3.21071 20.9757 3 20.467 3 19.9365V15.9365'
        stroke='#1c2433'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
    </svg>
  );
};

export const LeftArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.00033 12.799L1.16699 6.96566M1.16699 6.96566L7.00033 1.13232M1.16699 6.96566H12.8337'
        stroke='#4E4F52'
        strokeWidth='1.66674'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const GoogleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.52388 17.3973L6.88721 14.8253C6.6949 14.2412 6.59091 13.6163 6.59091 12.9663C6.59091 12.3164 6.6949 11.6915 6.88721 11.1074L3.52388 8.5354C2.86791 9.86905 2.5 11.3726 2.5 12.9663C2.5 14.56 2.86791 16.0636 3.52388 17.3973Z'
        fill='#FBBC05'
      />
      <path
        d='M6.88725 11.1073C7.66325 8.75038 9.8773 7.05722 12.5 7.05722C13.9091 7.05722 15.1819 7.55722 16.1819 8.3754L19.091 5.46631C17.3182 3.92085 15.0455 2.96631 12.5 2.96631C8.54828 2.96631 5.1505 5.2284 3.52393 8.53537L6.88725 11.1073Z'
        fill='#EA4335'
      />
      <path
        d='M12.4999 22.9662C8.54707 22.9662 5.1485 20.7029 3.52246 17.3944L6.88442 14.8169C7.65795 17.1782 9.87411 18.8753 12.4999 18.8753C13.7848 18.8753 14.9233 18.5727 15.8249 18.0037L19.0179 20.4757C17.27 22.1009 14.939 22.9662 12.4999 22.9662Z'
        fill='#34A853'
      />
      <path
        d='M12.5 11.1482H21.8182C21.9545 11.7391 22.0455 12.3755 22.0455 12.9664C22.0455 16.2257 20.8531 18.7696 19.0179 20.4759L15.825 18.0039C16.869 17.345 17.5953 16.3289 17.8636 15.0118H12.5V11.1482Z'
        fill='#4285F4'
      />
    </svg>
  );
};

export const RedirectLink = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M18 13.9365V19.9365C18 20.467 17.7893 20.9757 17.4142 21.3507C17.0391 21.7258 16.5304 21.9365 16 21.9365H5C4.46957 21.9365 3.96086 21.7258 3.58579 21.3507C3.21071 20.9757 3 20.467 3 19.9365V8.93652C3 8.40609 3.21071 7.89738 3.58579 7.52231C3.96086 7.14724 4.46957 6.93652 5 6.93652H11M10 14.9365L21 3.93652M21 3.93652H15M21 3.93652V9.93652'
        stroke='#413bbc'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
    </svg>
  );
};

export const FilipinoFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_60823)'>
        <rect width='20' height='15' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0V15H20V0H0Z'
          fill='#BF2714'
        />
        <mask
          id='mask0_270_60823'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='20'
          height='15'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V15H20V0H0Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_270_60823)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 -1.25V7.5H20V-1.25H0Z'
            fill='#3D58DB'
          />
        </g>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0V15L11.25 7.5L0 0Z'
          fill='#F7FCFF'
        />
        <mask
          id='mask1_270_60823'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='12'
          height='15'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V15L11.25 7.5L0 0Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask1_270_60823)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M8.50315 6.8251L9.30058 7.13262L9.77502 6.57429L9.78761 7.32101L10.5215 7.55973L9.74902 7.82194L9.79993 8.50813L9.29113 7.98249L8.49137 8.13461L8.96355 7.52921L8.50315 6.8251Z'
            fill='#FECA00'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M1.00316 10.5751L1.73614 10.8992L2.27503 10.3243L2.22317 11.0876L3.02153 11.3097L2.18458 11.5885L2.29994 12.2581L1.71721 11.7796L0.991373 11.8846L1.39911 11.2958L1.00316 10.5751Z'
            fill='#FECA00'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M1.00316 3.0751L1.81426 3.37399L2.27503 2.82429L2.30129 3.56238L3.02153 3.80973L2.2627 4.06331L2.29994 4.75813L1.79533 4.25446L0.991373 4.38461L1.47723 3.77058L1.00316 3.0751Z'
            fill='#FECA00'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M5.07594 9.08301C5.93888 9.08301 6.63844 8.38345 6.63844 7.52051C6.63844 6.65756 5.93888 5.95801 5.07594 5.95801C4.21299 5.95801 3.51344 6.65756 3.51344 7.52051C3.51344 8.38345 4.21299 9.08301 5.07594 9.08301Z'
            fill='#FECA00'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M4.89123 5.14981L4.9752 6.15356C4.98322 6.21451 5.03012 6.26307 5.09075 6.27322C5.16692 6.28598 5.23901 6.23456 5.25176 6.15839L5.36258 5.15804C5.36452 5.14641 5.3656 5.13465 5.36581 5.12285C5.36811 4.99125 5.26328 4.8827 5.13168 4.8804C5.11989 4.8802 5.10809 4.88087 5.0964 4.88241C4.9659 4.89959 4.87405 5.01932 4.89123 5.14981ZM4.62992 5.63492L4.75968 6.07156C4.77172 6.11209 4.8122 6.13719 4.85798 6.12912C4.89551 6.12025 4.91874 6.08264 4.90987 6.04511L4.80631 5.60689C4.7944 5.5565 4.74558 5.52387 4.69446 5.53214C4.69104 5.53269 4.68767 5.53346 4.68435 5.53445C4.64158 5.54716 4.6172 5.59214 4.62992 5.63492ZM5.33168 6.08976C5.32151 6.12695 5.34341 6.16535 5.38469 6.17651C5.42608 6.18519 5.46741 6.16152 5.48086 6.12143L5.62578 5.68958C5.63998 5.64727 5.61719 5.60147 5.57488 5.58727C5.5716 5.58617 5.56826 5.58528 5.56486 5.58461C5.51406 5.57456 5.46413 5.60547 5.45047 5.65542L5.33168 6.08976ZM6.62988 5.6509L5.93131 6.42228C5.89388 6.47106 5.89271 6.53855 5.9284 6.58861C5.97325 6.65148 6.06058 6.6661 6.12345 6.62126L6.95735 5.99001C6.96695 5.98316 6.97603 5.97561 6.98452 5.96742C7.0792 5.87598 7.08183 5.72511 6.9904 5.63042C6.98221 5.62194 6.97339 5.61407 6.96404 5.60689C6.85961 5.52677 6.71 5.54648 6.62988 5.6509ZM6.41737 7.28837L7.46046 7.20764C7.59096 7.19045 7.71068 7.28231 7.72787 7.41281C7.72941 7.4245 7.73008 7.43629 7.72987 7.44809C7.72758 7.57969 7.61903 7.68451 7.48742 7.68222C7.47563 7.68201 7.46387 7.68093 7.45224 7.67898L6.41254 7.56493C6.33637 7.55218 6.28495 7.4801 6.29771 7.40392C6.30786 7.34329 6.35642 7.2964 6.41737 7.28837ZM6.95873 8.94974L6.14865 8.24448C6.09987 8.20706 6.03238 8.20588 5.98232 8.24158C5.91945 8.28642 5.90483 8.37375 5.94967 8.43663L6.61962 9.27721C6.62647 9.28681 6.63402 9.29589 6.64221 9.30438C6.73365 9.39906 6.88452 9.40169 6.97921 9.31026C6.98769 9.30207 6.99556 9.29325 7.00274 9.2839C7.08286 9.17947 7.06315 9.02986 6.95873 8.94974ZM5.28256 8.73054L5.34441 9.78368C5.3616 9.91418 5.26974 10.0339 5.13924 10.0511C5.12755 10.0526 5.11576 10.0533 5.10396 10.0531C4.97236 10.0508 4.86753 9.94225 4.86983 9.81064C4.87004 9.79885 4.87112 9.78709 4.87307 9.77545L5.006 8.72571C5.01875 8.64954 5.09083 8.59813 5.16701 8.61088C5.22764 8.62103 5.27453 8.66959 5.28256 8.73054ZM3.63814 9.29949L4.32645 8.46182C4.36387 8.41304 4.36505 8.34555 4.32935 8.2955C4.28451 8.23262 4.19718 8.218 4.1343 8.26285L3.31067 8.96038C3.30107 8.96723 3.29198 8.97479 3.2835 8.98298C3.18882 9.07441 3.18618 9.22529 3.27762 9.31997C3.28581 9.32846 3.29462 9.33632 3.30398 9.3435C3.40841 9.42362 3.55802 9.40392 3.63814 9.29949ZM3.84039 7.59573L2.79089 7.68222C2.66039 7.6994 2.54067 7.60755 2.52348 7.47705C2.52194 7.46536 2.52127 7.45356 2.52148 7.44177C2.52377 7.31017 2.63232 7.20534 2.76393 7.20764C2.77572 7.20785 2.78748 7.20893 2.79911 7.21087L3.84522 7.31917C3.92139 7.33192 3.9728 7.40401 3.96005 7.48018C3.9499 7.54081 3.90134 7.58771 3.84039 7.59573ZM3.21897 5.95131L4.10911 6.63962C4.15789 6.67705 4.22538 6.67822 4.27543 6.64253C4.33831 6.59768 4.35293 6.51035 4.30808 6.44748L3.55807 5.62384C3.55123 5.61424 3.54367 5.60516 3.53548 5.59667C3.44405 5.50199 3.29317 5.49936 3.19849 5.59079C3.19 5.59898 3.18214 5.6078 3.17496 5.61715C3.09483 5.72158 3.11454 5.87119 3.21897 5.95131ZM5.8369 6.2119L6.0539 5.81139C6.07515 5.77216 6.12419 5.75759 6.16343 5.77884C6.16647 5.78049 6.1694 5.78233 6.17221 5.78436C6.21421 5.81465 6.22566 5.87225 6.19844 5.91631L5.9618 6.29941C5.94153 6.33221 5.89851 6.34238 5.86571 6.32211C5.82763 6.29545 5.81675 6.24908 5.8369 6.2119ZM6.93601 6.94309L6.49937 7.07285C6.45884 7.08489 6.43374 7.12537 6.44181 7.17115C6.45068 7.20868 6.48829 7.23191 6.52582 7.22304L6.96404 7.11949C7.01443 7.10758 7.04707 7.05875 7.03879 7.00763C7.03824 7.00422 7.03747 7.00084 7.03648 6.99752C7.02377 6.95475 6.97879 6.93038 6.93601 6.94309ZM6.35903 8.15007L6.75954 8.36707C6.79877 8.38833 6.81334 8.43737 6.79209 8.4766C6.79044 8.47964 6.7886 8.48258 6.78657 8.48538C6.75628 8.52738 6.69868 8.53883 6.65462 8.51162L6.27152 8.27497C6.23872 8.25471 6.22855 8.21169 6.24882 8.17888C6.27548 8.1408 6.32185 8.12992 6.35903 8.15007ZM5.62784 9.24919L5.49808 8.81254C5.48604 8.77201 5.44556 8.74691 5.39978 8.75498C5.36225 8.76385 5.33902 8.80146 5.34789 8.83899L5.45144 9.27721C5.46335 9.32761 5.51218 9.36024 5.5633 9.35196C5.56672 9.35141 5.57009 9.35064 5.57341 9.34965C5.61618 9.33694 5.64055 9.29196 5.62784 9.24919ZM4.42086 8.6722L4.20386 9.07271C4.1826 9.11194 4.13356 9.12652 4.09433 9.10526C4.09129 9.10361 4.08835 9.10177 4.08555 9.09975C4.04355 9.06945 4.0321 9.01185 4.05931 8.96779L4.29596 8.5847C4.31622 8.55189 4.35925 8.54172 4.39205 8.56199C4.43013 8.58865 4.44101 8.63502 4.42086 8.6722ZM3.32174 7.94101L3.75839 7.81125C3.79892 7.79921 3.82402 7.75873 3.81595 7.71295C3.80708 7.67542 3.76947 7.65219 3.73194 7.66106L3.29372 7.76462C3.24332 7.77653 3.21069 7.82535 3.21897 7.87647C3.21952 7.87989 3.22029 7.88326 3.22128 7.88658C3.23399 7.92935 3.27897 7.95373 3.32174 7.94101ZM3.89873 6.73403L3.49822 6.51703C3.45899 6.49578 3.44441 6.44674 3.46567 6.4075C3.46732 6.40446 3.46916 6.40153 3.47119 6.39872C3.50148 6.35672 3.55908 6.34527 3.60314 6.37249L3.98623 6.60913C4.01904 6.6294 4.02921 6.67242 4.00894 6.70522C3.98228 6.7433 3.93591 6.75418 3.89873 6.73403ZM6.2285 6.62924C6.195 6.64834 6.18334 6.69098 6.20464 6.72806C6.22777 6.76347 6.27373 6.77595 6.31159 6.75712L6.71943 6.55423C6.75938 6.53435 6.77565 6.48585 6.75578 6.4459C6.75424 6.4428 6.7525 6.4398 6.75058 6.43693C6.72176 6.3939 6.6646 6.38045 6.61962 6.40611L6.2285 6.62924ZM6.39442 7.69786C6.40558 7.65659 6.44398 7.63468 6.48117 7.64485L6.91551 7.76364C6.96547 7.7773 6.99637 7.82724 6.98632 7.87804C6.98565 7.88143 6.98476 7.88478 6.98366 7.88806C6.96946 7.93036 6.92366 7.95315 6.88135 7.93895L6.4495 7.79403C6.40941 7.78058 6.38574 7.73925 6.39442 7.69786ZM5.94169 8.54167C5.92259 8.50818 5.87995 8.49652 5.84287 8.51781C5.80747 8.54094 5.79498 8.5869 5.81381 8.62476L6.0167 9.0326C6.03658 9.07255 6.08508 9.08883 6.12503 9.06895C6.12813 9.06741 6.13113 9.06567 6.134 9.06375C6.17703 9.03493 6.19048 8.97777 6.16482 8.93279L5.94169 8.54167ZM4.87307 8.7076C4.91434 8.71875 4.93625 8.75715 4.92608 8.79435L4.80729 9.22869C4.79363 9.27864 4.7437 9.30954 4.69289 9.29949C4.6895 9.29882 4.68615 9.29793 4.68287 9.29683C4.64057 9.28263 4.61778 9.23683 4.63198 9.19452L4.7769 8.76267C4.79035 8.72259 4.83168 8.69891 4.87307 8.7076ZM4.02926 8.25487C4.06275 8.23576 4.07442 8.19312 4.05312 8.15604C4.02999 8.12064 3.98403 8.10815 3.94617 8.12699L3.53833 8.32988C3.49838 8.34975 3.4821 8.39825 3.50198 8.43821C3.50352 8.4413 3.50526 8.4443 3.50718 8.44717C3.536 8.4902 3.59316 8.50366 3.63814 8.478L4.02926 8.25487ZM3.86333 7.18624C3.85218 7.22752 3.81378 7.24942 3.77658 7.23925L3.34224 7.12046C3.29229 7.1068 3.26139 7.05687 3.27144 7.00607C3.27211 7.00267 3.273 6.99933 3.2741 6.99605C3.2883 6.95374 3.3341 6.93095 3.37641 6.94515L3.80826 7.09007C3.84834 7.10352 3.87202 7.14485 3.86333 7.18624ZM4.31606 6.34243C4.33517 6.37593 4.37781 6.38759 4.41489 6.36629C4.45029 6.34316 4.46278 6.2972 4.44395 6.25934L4.24105 5.8515C4.22118 5.81155 4.17268 5.79528 4.13272 5.81515C4.12963 5.81669 4.12663 5.81843 4.12376 5.82036C4.08073 5.84917 4.06727 5.90633 4.09293 5.95131L4.31606 6.34243Z'
            fill='#FECA00'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_270_60823'>
          <rect width='20' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PolishFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_60930)'>
        <rect width='20' height='15' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0V15H20V0H0Z'
          fill='#F7FCFF'
        />
        <mask
          id='mask0_270_60930'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='20'
          height='15'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V15H20V0H0Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_270_60930)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 7.5V15H20V7.5H0Z'
            fill='#C51918'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_270_60930'>
          <rect width='20' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PersianFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_60952)'>
        <rect width='20' height='15' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0V15H20V0H0Z'
          fill='#F7FCFF'
        />
        <mask
          id='mask0_270_60952'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='20'
          height='15'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V15H20V0H0Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_270_60952)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V5H20V0H0Z'
            fill='#5EAA22'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 10V15H20V10H0Z'
            fill='#E31D1C'
          />
          <path
            d='M0.232896 10.8543H-1.18839'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M-1.20303 11.4171V11.0908H-0.740367V11.4061H-0.272849V11.0912H-0.515404'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M0.211423 11.4038H-0.0241623V11.0977H0.471856V10.8469V11.4038H0.696317V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M0.948841 10.88C0.948841 10.9108 0.948841 11.4062 0.948841 11.4062H0.715851'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M2.67192 10.8543H1.25064'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M1.23599 11.4171V11.0908H1.69866V11.4061H2.16618V11.0912H1.92362'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M2.694 11.4038H2.45841V11.0977H2.95443V10.8469V11.4038H3.17889V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M3.43142 10.88C3.43142 10.9108 3.43142 11.4062 3.43142 11.4062H3.19843'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M5.1545 10.8543H3.73322'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M3.71857 11.4171V11.0908H4.18123V11.4061H4.64875V11.0912H4.4062'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M5.13302 11.4038H4.89744V11.0977H5.39346V10.8469V11.4038H5.61792V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M5.87044 10.88C5.87044 10.9108 5.87044 11.4062 5.87044 11.4062H5.63745'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M7.59352 10.8543H6.17224'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M6.15759 11.4171V11.0908H6.62026V11.4061H7.08778V11.0912H6.84522'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M7.57205 11.4038H7.33646V11.0977H7.83248V10.8469V11.4038H8.05694V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M8.30947 10.88C8.30947 10.9108 8.30947 11.4062 8.30947 11.4062H8.07648'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M10.0325 10.8543H8.61127'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M8.59662 11.4171V11.0908H9.05929V11.4061H9.5268V11.0912H9.28425'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M10.0546 11.4038H9.81905V11.0977H10.3151V10.8469V11.4038H10.5395V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M10.792 10.88C10.792 10.9108 10.792 11.4062 10.792 11.4062H10.5591'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M12.5151 10.8543H11.0938'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M11.0792 11.4171V11.0908H11.5419V11.4061H12.0094V11.0912H11.7668'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M12.5372 11.4038H12.3016V11.0977H12.7976V10.8469V11.4038H13.0221V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M13.2746 10.88C13.2746 10.9108 13.2746 11.4062 13.2746 11.4062H13.0416'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M14.9977 10.8543H13.5764'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M13.5618 11.4171V11.0908H14.0244V11.4061H14.492V11.0912H14.2494'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M15.0198 11.4038H14.7842V11.0977H15.2802V10.8469V11.4038H15.5047V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M15.7572 10.88C15.7572 10.9108 15.7572 11.4062 15.7572 11.4062H15.5242'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M17.4803 10.8543H16.059'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M16.0443 11.4171V11.0908H16.507V11.4061H16.9745V11.0912H16.732'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M17.4588 11.4038H17.2232V11.0977H17.7192V10.8469V11.4038H17.9437V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M18.1962 10.88C18.1962 10.9108 18.1962 11.4062 18.1962 11.4062H17.9632'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M19.9193 10.8543H18.498'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M18.4834 11.4171V11.0908H18.946V11.4061H19.4136V11.0912H19.171'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M20.0285 11.4038H19.7929V11.0977H20.2889V10.8469V11.4038H20.5134V10.8469'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M0.232896 3.22933H-1.18839'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M-1.20303 3.79205V3.4658H-0.740367V3.7811H-0.272849V3.46615H-0.515404'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M0.211423 3.77881H-0.0241623V3.47267H0.471856V3.22188V3.77881H0.696317V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M0.948841 3.255C0.948841 3.28579 0.948841 3.78116 0.948841 3.78116H0.715851'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M2.67192 3.22933H1.25064'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M1.23599 3.79205V3.4658H1.69866V3.7811H2.16618V3.46615H1.92362'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M2.694 3.77881H2.45841V3.47267H2.95443V3.22188V3.77881H3.17889V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M3.43142 3.255C3.43142 3.28579 3.43142 3.78116 3.43142 3.78116H3.19843'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M5.1545 3.22933H3.73322'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M3.71857 3.79205V3.4658H4.18123V3.7811H4.64875V3.46615H4.4062'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M5.13302 3.77881H4.89744V3.47267H5.39346V3.22188V3.77881H5.61792V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M5.87044 3.255C5.87044 3.28579 5.87044 3.78116 5.87044 3.78116H5.63745'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M7.59352 3.22933H6.17224'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M6.15759 3.79205V3.4658H6.62026V3.7811H7.08778V3.46615H6.84522'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M7.57205 3.77881H7.33646V3.47267H7.83248V3.22188V3.77881H8.05694V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M8.30947 3.255C8.30947 3.28579 8.30947 3.78116 8.30947 3.78116H8.07648'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M10.0325 3.22933H8.61127'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M8.59662 3.79205V3.4658H9.05929V3.7811H9.5268V3.46615H9.28425'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M10.0546 3.77881H9.81905V3.47267H10.3151V3.22188V3.77881H10.5395V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M10.792 3.255C10.792 3.28579 10.792 3.78116 10.792 3.78116H10.5591'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M12.5151 3.22933H11.0938'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M11.0792 3.79205V3.4658H11.5419V3.7811H12.0094V3.46615H11.7668'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M12.5372 3.77881H12.3016V3.47267H12.7976V3.22188V3.77881H13.0221V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M13.2746 3.255C13.2746 3.28579 13.2746 3.78116 13.2746 3.78116H13.0416'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M14.9977 3.22933H13.5764'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M13.5618 3.79205V3.4658H14.0244V3.7811H14.492V3.46615H14.2494'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M15.0198 3.77881H14.7842V3.47267H15.2802V3.22188V3.77881H15.5047V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M15.7572 3.255C15.7572 3.28579 15.7572 3.78116 15.7572 3.78116H15.5242'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M17.4803 3.22933H16.059'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M16.0443 3.79205V3.4658H16.507V3.7811H16.9745V3.46615H16.732'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M17.4588 3.77881H17.2232V3.47267H17.7192V3.22188V3.77881H17.9437V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M18.1962 3.255C18.1962 3.28579 18.1962 3.78116 18.1962 3.78116H17.9632'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M19.9193 3.22933H18.498'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M18.4834 3.79205V3.4658H18.946V3.7811H19.4136V3.46615H19.171'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            d='M20.0285 3.77881H19.7929V3.47267H20.2889V3.22188V3.77881H20.5134V3.22188'
            stroke='#F7FCFF'
            strokeWidth='0.625'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M9.12891 5.15625C9.12891 5.15625 9.39599 5.29688 9.66935 5.29688C9.94272 5.29688 10.2178 5.15625 10.2178 5.15625V5.34375C10.2178 5.34375 9.9175 5.48438 9.65156 5.48438C9.38562 5.48438 9.12891 5.34375 9.12891 5.34375V5.15625ZM7.16023 7.36913C7.16023 6.25788 8.68648 5.53125 8.68648 5.53125C8.68648 5.53125 7.80433 6.00388 7.80433 7.32256C7.80433 8.64123 8.26227 9.21229 8.26227 9.21229C8.26227 9.21229 7.16023 8.48038 7.16023 7.36913ZM12.3088 7.3078C12.3088 6.19655 10.784 5.53125 10.784 5.53125C10.784 5.53125 11.6661 6.00388 11.6661 7.32256C11.6661 8.64123 11.2082 9.21229 11.2082 9.21229C11.2082 9.21229 12.3088 8.41905 12.3088 7.3078ZM8.20218 7.61099C8.14402 6.50126 9.06719 5.50658 9.06719 5.50658C9.06719 5.50658 8.73118 5.96365 8.80019 7.28052C8.82389 7.73267 9.00198 8.40538 9.22637 8.80199V5.57812H10.1639V8.82995C10.3886 8.45948 10.5617 7.82785 10.5857 7.36913C10.6547 6.05226 10.3348 5.50658 10.3348 5.50658C10.3348 5.50658 11.258 6.50126 11.1998 7.61099C11.1652 8.27191 10.6566 8.97089 10.251 9.42817C10.4481 9.47212 10.7123 9.52571 11.0755 9.59742C11.0833 9.6376 11.0023 9.63573 10.8415 9.63204C10.6639 9.62795 10.389 9.62163 10.0285 9.66718C9.86277 9.83705 9.74741 9.93774 9.74741 9.93774C9.74741 9.93774 9.72918 9.9131 9.70101 9.87902C9.67284 9.9131 9.6546 9.93774 9.6546 9.93774C9.6546 9.93774 9.53925 9.83705 9.37351 9.66719C9.01302 9.62163 8.73807 9.62795 8.5605 9.63204C8.39969 9.63573 8.31875 9.6376 8.3265 9.59742C8.68971 9.52571 8.95394 9.47212 9.15106 9.42817C8.74537 8.97089 8.23681 8.27191 8.20218 7.61099Z'
            fill='#E31D1C'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_270_60952'>
          <rect width='20' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NetherlandsFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='12'
      viewBox='0 0 16 12'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_55203)'>
        <rect width='16' height='12' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0V12H16V0H0Z'
          fill='#F7FCFF'
        />
        <mask
          id='mask0_270_55203'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='16'
          height='12'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V12H16V0H0Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_270_55203)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V4H16V0H0Z'
            fill='#E31D1C'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 8V12H16V8H0Z'
            fill='#3D58DB'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_270_55203'>
          <rect width='16' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TurkishFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_60794)'>
        <rect width='20' height='15' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0V15H20V0H0Z'
          fill='#E31D1C'
        />
        <mask
          id='mask0_270_60794'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='20'
          height='15'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V15H20V0H0Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_270_60794)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M10.0159 10.071C8.67757 9.74127 7.62936 8.62106 7.64153 6.97897C7.65291 5.44184 8.58357 4.14256 10.0548 3.79083C11.526 3.4391 12.8213 4.18574 12.8213 4.18574C12.4147 3.22585 11.0021 2.55151 9.84393 2.55345C7.68817 2.55706 5.39012 4.30534 5.37031 6.97897C5.34977 9.75084 7.83118 11.3294 10.0136 11.3258C11.7631 11.3228 12.593 10.1259 12.7648 9.61669C12.7648 9.61669 11.3542 10.4007 10.0159 10.071ZM13.0646 6.45413L11.7311 6.94392L13.2356 7.47467L13.21 9.06053L14.2013 7.87078L15.8389 7.98977L14.5412 6.8743L15.3931 5.68443L14.006 6.15128L13.0145 5.04904L13.0646 6.45413Z'
            fill='#F7FCFF'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_270_60794'>
          <rect width='20' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PortugeseFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5 0H20V15H5V0Z'
        fill='#EF0000'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0 0H7.5V15H0V0Z'
        fill='#2F8D00'
      />
      <mask
        id='mask0_270_59834'
        maskUnits='userSpaceOnUse'
        x='2'
        y='2'
        width='11'
        height='11'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.44048 12.3795C4.77768 12.3795 2.61905 10.1949 2.61905 7.5C2.61905 4.80512 4.77768 2.62048 7.44048 2.62048C10.1033 2.62048 12.2619 4.80512 12.2619 7.5C12.2619 10.1949 10.1033 12.3795 7.44048 12.3795Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_270_59834)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.14286 2.5H7.76786V4.18675H7.14286V2.5Z'
          fill='#FFE017'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.14286 10.9337H7.76786V12.5H7.14286V10.9337Z'
          fill='#FFE017'
        />
        <path
          d='M2.69654 7.75236L2.5218 7.30405C4.45004 6.53426 5.90539 6.03781 6.89288 5.81408C8.34171 5.48582 9.93363 5.24296 11.6688 5.0853L11.7113 5.56529C9.99612 5.72114 8.42461 5.9609 6.99691 6.28437C6.03882 6.50144 4.60368 6.99099 2.69654 7.75236Z'
          fill='#FFE017'
        />
        <path
          d='M11.963 4.78993L11.8212 5.25C10.3639 4.78993 9.17677 4.59216 8.26425 4.65342L8.23273 4.17255C9.21248 4.10678 10.4544 4.31367 11.963 4.78993Z'
          fill='#FFE017'
        />
        <path
          d='M12.4673 7.36236L12.1979 7.75976C11.455 7.24397 10.5397 6.98489 9.44583 6.98489V6.50296C10.6317 6.50296 11.6409 6.78864 12.4673 7.36236Z'
          fill='#FFE017'
        />
        <path
          d='M12.0638 7.50659L12.1869 7.97213C10.5852 8.40597 9.08151 8.65211 7.67561 8.71007C6.26001 8.76843 4.61009 8.52141 2.72445 7.97089L2.85644 7.50784C4.69626 8.04499 6.29665 8.28459 7.65622 8.22854C9.02549 8.17209 10.4947 7.9316 12.0638 7.50659Z'
          fill='#FFE017'
        />
        <path
          d='M11.8823 9.77243L11.1296 10.5441C9.69919 9.115 8.43986 8.09314 7.35938 7.47916C6.26043 6.85469 4.82732 6.22058 3.06224 5.57939L3.42421 4.55881C5.24134 5.2189 6.72717 5.87634 7.88393 6.53367C9.05916 7.20149 10.3894 8.28087 11.8823 9.77243Z'
          fill='#FFE017'
        />
        <path
          d='M3.41144 10.2096L3.12653 9.82341C3.16632 9.79334 3.23731 9.7432 3.33512 9.67966C3.49662 9.57474 3.67596 9.46999 3.86891 9.37211C4.40035 9.10252 4.93344 8.9342 5.44188 8.91874C5.46675 8.91798 5.49151 8.9176 5.51617 8.9176V9.39953C5.49631 9.39953 5.47631 9.39984 5.45619 9.40045C5.02771 9.41348 4.55716 9.56205 4.08229 9.80294C3.90529 9.89273 3.74037 9.98906 3.59236 10.0852C3.54084 10.1187 3.49526 10.1496 3.4562 10.1772C3.43343 10.1933 3.41831 10.2044 3.41144 10.2096Z'
          fill='#FFE017'
        />
        <path
          d='M3.6326 10.3766L3.75251 9.91023C5.34009 10.3283 6.56402 10.5367 7.4182 10.5367C8.26919 10.5367 9.53581 10.2909 11.2098 9.7977L11.3429 10.2604C9.62931 10.7653 8.32381 11.0186 7.4182 11.0186C6.51577 11.0186 5.25594 10.8041 3.6326 10.3766Z'
          fill='#FFE017'
        />
        <path
          d='M3.01403 6.05902L3.76845 5.28906L4.87303 6.39759L4.1186 7.16755L3.01403 6.05902Z'
          fill='#FFE017'
        />
        <path
          d='M9.27246 9.90483L9.83361 8.98111L11.5859 10.0714L11.0247 10.9951L9.27246 9.90483Z'
          fill='#FFE017'
        />
      </g>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.61905 7.5C2.61905 10.1949 4.77768 12.3795 7.44048 12.3795C10.1033 12.3795 12.2619 10.1949 12.2619 7.5C12.2619 4.80512 10.1033 2.62048 7.44048 2.62048C4.77768 2.62048 2.61905 4.80512 2.61905 7.5ZM11.6667 7.56024C11.6667 9.88915 9.80119 11.7771 7.5 11.7771C5.19881 11.7771 3.33333 9.88915 3.33333 7.56024C3.33333 5.23133 5.19881 3.34337 7.5 3.34337C9.80119 3.34337 11.6667 5.23133 11.6667 7.56024Z'
        fill='#F9E813'
      />
      <path
        d='M4.78543 4.49078V8.40373C5.04302 9.95253 5.91081 10.7269 7.3888 10.7269C8.8668 10.7269 9.73458 9.95253 9.99217 8.40373V4.49078H4.78543Z'
        fill='white'
      />
      <path
        d='M4.42829 4.12933H10.3493V8.43393L10.3444 8.46372C10.0583 10.1835 9.04436 11.0884 7.3888 11.0884C5.73325 11.0884 4.71927 10.1835 4.43325 8.46372L4.42829 8.43393V4.12933Z'
        fill='#C51918'
      />
      <path
        d='M5.78264 5.44418H8.99497V8.21974C8.99497 8.21974 8.75659 9.65306 7.3888 9.65306C6.02102 9.65306 5.78264 8.21974 5.78264 8.21974V5.44418Z'
        fill='#F7FCFF'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5 4.4277H5.45181V4.72891H5V4.4277Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 4.54819H5.59524V4.69879H4.76191V4.54819Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 4.66867H5.21371V4.81927H4.76191V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.23809 4.66867H5.6899V4.81927H5.23809V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 5.03012H5.06311V5.48193H4.76191V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.35714 5.03012H5.65835V5.48193H5.35714V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.11905 5.03012H5.26965V5.48193H5.11905V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 4.90964H5.59524V5.06024H4.76191V4.90964Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 5.27109H5.59524V5.42169H4.76191V5.27109Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.88095 4.78915H5.03156V4.93976H4.88095V4.78915Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.35714 4.78915H5.50775V4.93976H5.35714V4.78915Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.11905 4.66867H5.26965V4.96988H5.11905V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.26191 4.4277H7.71371V4.72891H7.26191V4.4277Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.02381 4.54819H7.85714V4.69879H7.02381V4.54819Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.02381 4.66867H7.47562V4.81927H7.02381V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.5 4.66867H7.95181V4.81927H7.5V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.02381 5.03012H7.32502V5.48193H7.02381V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.61905 5.03012H7.92025V5.48193H7.61905V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.38095 5.03012H7.53156V5.48193H7.38095V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.02381 4.90964H7.85714V5.06024H7.02381V4.90964Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.02381 5.27109H7.85714V5.42169H7.02381V5.27109Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.14286 4.78915H7.29346V4.93976H7.14286V4.78915Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.61905 4.78915H7.76965V4.93976H7.61905V4.78915Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.38095 4.66867H7.53156V4.96988H7.38095V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.40476 4.4277H9.85657V4.72891H9.40476V4.4277Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 4.54819H10V4.69879H9.16667V4.54819Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 4.66867H9.61848V4.81927H9.16667V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.64286 4.66867H10.0947V4.81927H9.64286V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 5.03012H9.46787V5.48193H9.16667V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.76191 5.03012H10.0631V5.48193H9.76191V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.52381 5.03012H9.67441V5.48193H9.52381V5.03012Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 4.90964H10V5.06024H9.16667V4.90964Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 5.27109H10V5.42169H9.16667V5.27109Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.28572 4.78915H9.43632V4.93976H9.28572V4.78915Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.76191 4.78915H9.91251V4.93976H9.76191V4.78915Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.52381 4.66867H9.67441V4.96988H9.52381V4.66867Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.40476 6.59637H9.85657V6.89758H9.40476V6.59637Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 6.71686H10V6.86746H9.16667V6.71686Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 6.83734H9.61848V6.98794H9.16667V6.83734Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.64286 6.83734H10.0947V6.98794H9.64286V6.83734Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 7.19879H9.46787V7.6506H9.16667V7.19879Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.76191 7.19879H10.0631V7.6506H9.76191V7.19879Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.52381 7.19879H9.67441V7.6506H9.52381V7.19879Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 7.07831H10V7.22891H9.16667V7.07831Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.16667 7.43976H10V7.59036H9.16667V7.43976Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.28572 6.95782H9.43632V7.10843H9.28572V6.95782Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.76191 6.95782H9.91251V7.10843H9.76191V6.95782Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.52381 6.83734H9.67441V7.13855H9.52381V6.83734Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5 6.59637H5.45181V6.89758H5V6.59637Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 6.71686H5.59524V6.86746H4.76191V6.71686Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 6.83734H5.21371V6.98794H4.76191V6.83734Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.23809 6.83734H5.6899V6.98794H5.23809V6.83734Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 7.19879H5.06311V7.6506H4.76191V7.19879Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.35714 7.19879H5.65835V7.6506H5.35714V7.19879Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.11905 7.19879H5.26965V7.6506H5.11905V7.19879Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 7.07831H5.59524V7.22891H4.76191V7.07831Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76191 7.43976H5.59524V7.59036H4.76191V7.43976Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.88095 6.95782H5.03156V7.10843H4.88095V6.95782Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.35714 6.95782H5.50775V7.10843H5.35714V6.95782Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.11905 6.83734H5.26965V7.13855H5.11905V6.83734Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.28985 9.31494L5.58026 8.96884L5.811 9.16245L5.52058 9.50855L5.28985 9.31494Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.2291 9.5748L5.76475 8.93643L5.88012 9.03323L5.34446 9.6716L5.2291 9.5748Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.32139 9.65222L5.61181 9.30612L5.72718 9.40292L5.43676 9.74903L5.32139 9.65222Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.62748 9.28745L5.9179 8.94134L6.03326 9.03815L5.74285 9.38425L5.62748 9.28745Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.59827 9.88455L5.79188 9.65382L6.13799 9.94423L5.94438 10.175L5.59827 9.88455Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.98089 9.42859L6.1745 9.19785L6.5206 9.48827L6.32699 9.719L5.98089 9.42859Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.82784 9.61099L5.92465 9.49562L6.27075 9.78604L6.17395 9.90141L5.82784 9.61099Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.50598 9.80713L6.04164 9.16876L6.15701 9.26556L5.62135 9.90393L5.50598 9.80713Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.78286 10.0395L6.31852 9.40109L6.43389 9.49789L5.89823 10.1363L5.78286 10.0395Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.49021 9.63849L5.58701 9.52312L5.70238 9.61993L5.60558 9.73529L5.49021 9.63849Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.7963 9.27371L5.8931 9.15834L6.00847 9.25515L5.91167 9.37052L5.7963 9.27371Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.55096 9.37863L5.64777 9.26326L5.8785 9.45687L5.7817 9.57224L5.55096 9.37863Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.36154 9.04138L9.65195 9.38749L9.42122 9.5811L9.1308 9.23499L9.36154 9.04138Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.1162 8.93643L9.65186 9.5748L9.53649 9.67161L9.00083 9.03324L9.1162 8.93643Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.0239 9.01385L9.31432 9.35996L9.19895 9.45676L8.90853 9.11066L9.0239 9.01385Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.32999 9.37866L9.62041 9.72477L9.50504 9.82157L9.21463 9.47547L9.32999 9.37866Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.74702 9.24619L8.94063 9.47692L8.59453 9.76734L8.40092 9.5366L8.74702 9.24619Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.12963 9.70218L9.32324 9.93292L8.97714 10.2233L8.78353 9.9926L9.12963 9.70218Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.97659 9.51978L9.07339 9.63514L8.72729 9.92556L8.63048 9.81019L8.97659 9.51978Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.83931 9.16876L9.37497 9.80713L9.2596 9.90394L8.72395 9.26557L8.83931 9.16876Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.56243 9.40109L9.09809 10.0395L8.98272 10.1363L8.44706 9.4979L8.56243 9.40109Z'
        fill='#060101'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.00813 9.1825L9.10494 9.29786L8.98957 9.39467L8.89276 9.2793L9.00813 9.1825Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.31422 9.5473L9.41103 9.66267L9.29566 9.75948L9.19885 9.64411L9.31422 9.5473Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.25347 9.28745L9.35028 9.40281L9.11954 9.59642L9.02274 9.48106L9.25347 9.28745Z'
        fill='#F9E813'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.84902 5.75299H7.02381V6.35391C7.02381 6.35391 7.08505 6.66423 7.43642 6.66423C7.78778 6.66423 7.84902 6.35391 7.84902 6.35391V5.75299ZM7.38095 5.99395C7.38095 6.06049 7.32765 6.11444 7.26191 6.11444C7.19616 6.11444 7.14286 6.06049 7.14286 5.99395C7.14286 5.92741 7.19616 5.87347 7.26191 5.87347C7.32765 5.87347 7.38095 5.92741 7.38095 5.99395ZM7.26191 6.59636C7.32765 6.59636 7.38095 6.54242 7.38095 6.47588C7.38095 6.40934 7.32765 6.3554 7.26191 6.3554C7.19616 6.3554 7.14286 6.40934 7.14286 6.47588C7.14286 6.54242 7.19616 6.59636 7.26191 6.59636ZM7.7381 6.47588C7.7381 6.54242 7.6848 6.59636 7.61905 6.59636C7.5533 6.59636 7.5 6.54242 7.5 6.47588C7.5 6.40934 7.5533 6.3554 7.61905 6.3554C7.6848 6.3554 7.7381 6.40934 7.7381 6.47588ZM7.44048 6.3554C7.50623 6.3554 7.55953 6.30146 7.55953 6.23492C7.55953 6.16838 7.50623 6.11444 7.44048 6.11444C7.37473 6.11444 7.32143 6.16838 7.32143 6.23492C7.32143 6.30146 7.37473 6.3554 7.44048 6.3554ZM7.7381 5.99395C7.7381 6.06049 7.6848 6.11444 7.61905 6.11444C7.5533 6.11444 7.5 6.06049 7.5 5.99395C7.5 5.92741 7.5533 5.87347 7.61905 5.87347C7.6848 5.87347 7.7381 5.92741 7.7381 5.99395Z'
        fill='#013399'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.84902 7.07831H7.02381V7.67923C7.02381 7.67923 7.08505 7.98955 7.43642 7.98955C7.78778 7.98955 7.84902 7.67923 7.84902 7.67923V7.07831ZM7.38095 7.31927C7.38095 7.38581 7.32765 7.43975 7.26191 7.43975C7.19616 7.43975 7.14286 7.38581 7.14286 7.31927C7.14286 7.25273 7.19616 7.19879 7.26191 7.19879C7.32765 7.19879 7.38095 7.25273 7.38095 7.31927ZM7.26191 7.92168C7.32765 7.92168 7.38095 7.86774 7.38095 7.8012C7.38095 7.73466 7.32765 7.68072 7.26191 7.68072C7.19616 7.68072 7.14286 7.73466 7.14286 7.8012C7.14286 7.86774 7.19616 7.92168 7.26191 7.92168ZM7.7381 7.8012C7.7381 7.86774 7.6848 7.92168 7.61905 7.92168C7.5533 7.92168 7.5 7.86774 7.5 7.8012C7.5 7.73466 7.5533 7.68072 7.61905 7.68072C7.6848 7.68072 7.7381 7.73466 7.7381 7.8012ZM7.44048 7.68072C7.50623 7.68072 7.55953 7.62678 7.55953 7.56024C7.55953 7.4937 7.50623 7.43975 7.44048 7.43975C7.37473 7.43975 7.32143 7.4937 7.32143 7.56024C7.32143 7.62678 7.37473 7.68072 7.44048 7.68072ZM7.7381 7.31927C7.7381 7.38581 7.6848 7.43975 7.61905 7.43975C7.5533 7.43975 7.5 7.38581 7.5 7.31927C7.5 7.25273 7.5533 7.19879 7.61905 7.19879C7.6848 7.19879 7.7381 7.25273 7.7381 7.31927Z'
        fill='#013399'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.92045 7.07831H8.09524V7.67923C8.09524 7.67923 8.15647 7.98955 8.50784 7.98955C8.85921 7.98955 8.92045 7.67923 8.92045 7.67923V7.07831ZM8.45238 7.31927C8.45238 7.38581 8.39908 7.43975 8.33333 7.43975C8.26758 7.43975 8.21429 7.38581 8.21429 7.31927C8.21429 7.25273 8.26758 7.19879 8.33333 7.19879C8.39908 7.19879 8.45238 7.25273 8.45238 7.31927ZM8.33333 7.92168C8.39908 7.92168 8.45238 7.86774 8.45238 7.8012C8.45238 7.73466 8.39908 7.68072 8.33333 7.68072C8.26758 7.68072 8.21429 7.73466 8.21429 7.8012C8.21429 7.86774 8.26758 7.92168 8.33333 7.92168ZM8.80952 7.8012C8.80952 7.86774 8.75622 7.92168 8.69048 7.92168C8.62473 7.92168 8.57143 7.86774 8.57143 7.8012C8.57143 7.73466 8.62473 7.68072 8.69048 7.68072C8.75622 7.68072 8.80952 7.73466 8.80952 7.8012ZM8.5119 7.68072C8.57765 7.68072 8.63095 7.62678 8.63095 7.56024C8.63095 7.4937 8.57765 7.43975 8.5119 7.43975C8.44616 7.43975 8.39286 7.4937 8.39286 7.56024C8.39286 7.62678 8.44616 7.68072 8.5119 7.68072ZM8.80952 7.31927C8.80952 7.38581 8.75622 7.43975 8.69048 7.43975C8.62473 7.43975 8.57143 7.38581 8.57143 7.31927C8.57143 7.25273 8.62473 7.19879 8.69048 7.19879C8.75622 7.19879 8.80952 7.25273 8.80952 7.31927Z'
        fill='#013399'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.77759 7.07831H5.95238V7.67923C5.95238 7.67923 6.01362 7.98955 6.36498 7.98955C6.71635 7.98955 6.77759 7.67923 6.77759 7.67923V7.07831ZM6.30952 7.31927C6.30952 7.38581 6.25622 7.43975 6.19048 7.43975C6.12473 7.43975 6.07143 7.38581 6.07143 7.31927C6.07143 7.25273 6.12473 7.19879 6.19048 7.19879C6.25622 7.19879 6.30952 7.25273 6.30952 7.31927ZM6.19048 7.92168C6.25622 7.92168 6.30952 7.86774 6.30952 7.8012C6.30952 7.73466 6.25622 7.68072 6.19048 7.68072C6.12473 7.68072 6.07143 7.73466 6.07143 7.8012C6.07143 7.86774 6.12473 7.92168 6.19048 7.92168ZM6.66667 7.8012C6.66667 7.86774 6.61337 7.92168 6.54762 7.92168C6.48187 7.92168 6.42857 7.86774 6.42857 7.8012C6.42857 7.73466 6.48187 7.68072 6.54762 7.68072C6.61337 7.68072 6.66667 7.73466 6.66667 7.8012ZM6.36905 7.68072C6.4348 7.68072 6.4881 7.62678 6.4881 7.56024C6.4881 7.4937 6.4348 7.43975 6.36905 7.43975C6.3033 7.43975 6.25 7.4937 6.25 7.56024C6.25 7.62678 6.3033 7.68072 6.36905 7.68072ZM6.66667 7.31927C6.66667 7.38581 6.61337 7.43975 6.54762 7.43975C6.48187 7.43975 6.42857 7.38581 6.42857 7.31927C6.42857 7.25273 6.48187 7.19879 6.54762 7.19879C6.61337 7.19879 6.66667 7.25273 6.66667 7.31927Z'
        fill='#013399'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.84902 8.40359H7.02381V9.00452C7.02381 9.00452 7.08505 9.31483 7.43642 9.31483C7.78778 9.31483 7.84902 9.00452 7.84902 9.00452V8.40359ZM7.38095 8.64456C7.38095 8.7111 7.32765 8.76504 7.26191 8.76504C7.19616 8.76504 7.14286 8.7111 7.14286 8.64456C7.14286 8.57802 7.19616 8.52408 7.26191 8.52408C7.32765 8.52408 7.38095 8.57802 7.38095 8.64456ZM7.26191 9.24697C7.32765 9.24697 7.38095 9.19303 7.38095 9.12649C7.38095 9.05995 7.32765 9.006 7.26191 9.006C7.19616 9.006 7.14286 9.05995 7.14286 9.12649C7.14286 9.19303 7.19616 9.24697 7.26191 9.24697ZM7.7381 9.12649C7.7381 9.19303 7.6848 9.24697 7.61905 9.24697C7.5533 9.24697 7.5 9.19303 7.5 9.12649C7.5 9.05995 7.5533 9.006 7.61905 9.006C7.6848 9.006 7.7381 9.05995 7.7381 9.12649ZM7.44048 9.006C7.50623 9.006 7.55953 8.95206 7.55953 8.88552C7.55953 8.81898 7.50623 8.76504 7.44048 8.76504C7.37473 8.76504 7.32143 8.81898 7.32143 8.88552C7.32143 8.95206 7.37473 9.006 7.44048 9.006ZM7.7381 8.64456C7.7381 8.7111 7.6848 8.76504 7.61905 8.76504C7.5533 8.76504 7.5 8.7111 7.5 8.64456C7.5 8.57802 7.5533 8.52408 7.61905 8.52408C7.6848 8.52408 7.7381 8.57802 7.7381 8.64456Z'
        fill='#013399'
      />
    </svg>
  );
};

export const ItalianFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_60885)'>
        <rect width='20' height='15' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14 0H20V15H14V0Z'
          fill='#C51918'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0H6V15H0V0Z'
          fill='#5EAA22'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6 0H14V15H6V0Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_270_60885'>
          <rect width='20' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FranceFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='19'
      viewBox='0 0 3 3'
      {...props}
    >
      <g>
        <path fill='#EC1920' d='M0 0h3v2H0z' />
        <path fill='#fff' d='M0 0h2v2H0z' />
        <path fill='#051440' d='M0 0h1v2H0z' />
      </g>
    </svg>
  );
};

export const GermanFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_60956)'>
        <rect width='20' height='15' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 10H20V15H0V10Z'
          fill='#FFD018'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 5H20V10H0V5Z'
          fill='#E31D1C'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0H20V5H0V0Z'
          fill='#272727'
        />
      </g>
      <defs>
        <clipPath id='clip0_270_60956'>
          <rect width='20' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EnglishFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 60 30'
      {...props}
    >
      <clipPath id='s'>
        <path d='M0,0 v30 h60 v-30 z' />
      </clipPath>
      <clipPath id='t'>
        <path d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z' />
      </clipPath>
      <g clipPath='url(#s)'>
        <path d='M0,0 v30 h60 v-30 z' fill='#012169' />
        <path d='M0,0 L60,30 M60,0 L0,30' stroke='#fff' strokeWidth='6' />
        <path
          d='M0,0 L60,30 M60,0 L0,30'
          clipPath='url(#t)'
          stroke='#C8102E'
          strokeWidth='4'
        />
        <path d='M30,0 v30 M0,15 h60' stroke='#fff' strokeWidth='10' />
        <path d='M30,0 v30 M0,15 h60' stroke='#C8102E' strokeWidth='6' />
      </g>
    </svg>
  );
};

export const SpanishFlag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_270_60959)'>
        <rect width='20' height='15' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 0V15H20V0H0Z'
          fill='#FFB400'
        />
        <mask
          id='mask0_270_60959'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='20'
          height='15'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V15H20V0H0Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_270_60959)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 0V3.75H20V0H0Z'
            fill='#C51918'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 11.25V15H20V11.25H0Z'
            fill='#C51918'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_270_60959'>
          <rect width='20' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox='0 0 24 24'
      width='24'
      height='24'
      stroke='currentColor'
      strokeWidth='2'
      fill='none'
      stroke-linecap='round'
      stroke-linejoin='round'
      {...props}
      // class='css-i6dzq1'
    >
      <line x1='5' y1='12' x2='19' y2='12'></line>
      <polyline points='12 5 19 12 12 19'></polyline>
    </svg>
  );
};

export const HelpIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='13'
      height='12'
      viewBox='0 0 13 12'
      fill='none'
      {...props}
    >
      <rect
        y='-0.000332832'
        width='12.0075'
        height='12.0006'
        rx='6.0003'
        fill='#7C98B6'
      />
      <path
        d='M6.00745 9.00027V5.99997M6.00745 2.99967H5.99995'
        stroke='white'
        strokeWidth='1.50015'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const BackIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      stroke='#3b424f'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <polyline points='15 18 9 12 15 6'></polyline>
    </svg>
  );
};

export const DataTransfer = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      {...props}
    >
      <defs></defs>
      <path
        fill='none'
        stroke='#1e1e1e'
        stroke-linecap='round'
        stroke-linejoin='round'
        strokeWidth='24px'
        d='M286.43,192.52V29.44c0-7.42-6.01-13.44-13.44-13.44H59.1c-7.42,0-13.44,6.01-13.44,13.44v276.6c0,7.42,6.01,13.44,13.44,13.44h166.48'
      />
      <rect
        fill='none'
        stroke='#1e1e1e'
        stroke-linecap='round'
        stroke-linejoin='round'
        strokeWidth='24px'
        x='225.57'
        y='192.52'
        width='240.77'
        height='303.48'
        rx='12'
        ry='12'
      />
      <line
        fill='none'
        stroke='#1e1e1e'
        stroke-linecap='round'
        stroke-linejoin='round'
        strokeWidth='24px'
        x1='89.67'
        y1='67.86'
        x2='242.42'
        y2='67.86'
      />
      <line
        fill='none'
        stroke='#1e1e1e'
        stroke-linecap='round'
        stroke-linejoin='round'
        strokeWidth='24px'
        x1='89.67'
        y1='114.8'
        x2='242.42'
        y2='114.8'
      />
      <line
        fill='none'
        stroke='#1e1e1e'
        stroke-linecap='round'
        stroke-linejoin='round'
        strokeWidth='24px'
        x1='89.67'
        y1='161.75'
        x2='242.42'
        y2='161.75'
      />
      <line
        fill='none'
        stroke='#1e1e1e'
        stroke-linecap='round'
        stroke-linejoin='round'
        strokeWidth='24px'
        x1='89.67'
        y1='208.69'
        x2='181.99'
        y2='208.69'
      />
      <path
        fill='#1e1e1e'
        strokeWidth='0px'
        d='M303.51,431.9c-50.32-1.39-103.55-9.86-145.44-39.83-37.27-26.26-57.84-70.23-57.34-115.41.04-6.32.37-12.55,1.38-18.92.16-1.03,1.14-1.74,2.17-1.57,1,.16,1.69,1.08,1.58,2.08-1.26,12.04-.51,24.54,1.46,36.51,16.82,97.04,110.07,121.85,196.22,119.27,4.93-.11,9.02,3.8,9.13,8.74.13,5.08-4.08,9.27-9.16,9.13h0Z'
      />
      <path
        fill='#1e1e1e'
        strokeWidth='0px'
        d='M294.72,387.58c8.55,6.24,32.36,22.32,64.6,33.53.96.33,1.03,1.66.1,2.08-9.63,4.34-43.67,20.32-63.2,37.8-.87.77-2.19-.12-1.79-1.22l13.52-37.5-14.92-33.33c-.47-1.05.75-2.04,1.68-1.36Z'
      />
    </svg>
  );
};

export const GreenTick = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='1.5'
        y='1.5'
        width='27'
        height='27'
        rx='13.5'
        stroke='#D7EAE2'
        strokeWidth='3'
      />
      <rect x='4' y='4' width='22' height='22' rx='11' fill='#1B875A' />
      <rect
        x='4'
        y='4'
        width='22'
        height='22'
        rx='11'
        stroke='#1B875A'
        strokeWidth='2'
      />
      <path
        d='M20.999 10.5L12.749 18.75L8.99902 15'
        stroke='white'
        strokeWidth='1.66674'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const RoundedLoadCircle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='1' y='1' width='24' height='24' rx='12' fill='white' />
      <rect
        x='1'
        y='1'
        width='24'
        height='24'
        rx='12'
        stroke='#8C9098'
        strokeWidth='2'
        stroke-linecap='round'
        stroke-dasharray='4 4'
      />
    </svg>
  );
};

export const PaymentLink = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 128.000000 128.000000'
      preserveAspectRatio='xMidYMid meet'
      {...props}
    >
      <g
        transform='translate(0.000000,128.000000) scale(0.100000,-0.100000)'
        fill='#8C9098'
        strokeWidth='30'
        // stroke='none'
      >
        <path
          d='M386 1265 c-42 -15 -138 -103 -162 -147 -17 -32 -18 -111 -3 -141 22
-42 41 -58 56 -46 11 10 9 17 -8 46 -22 36 -27 89 -11 119 18 34 129 133 156
140 55 14 117 -23 136 -82 17 -51 6 -79 -57 -145 -36 -38 -53 -64 -50 -74 10
-25 22 -18 85 50 65 69 80 106 68 170 -7 35 -45 89 -75 104 -33 18 -96 21
-135 6z'
        />
        <path
          d='M825 1184 c-49 -25 -100 -52 -112 -60 l-23 -14 57 -115 c54 -107 73
-130 88 -105 3 5 -14 49 -39 97 -25 48 -44 89 -42 91 2 2 37 -13 77 -33 154
-78 247 -220 262 -400 3 -42 31 -40 35 3 9 94 -57 249 -143 334 -52 53 -157
118 -189 118 -34 0 -13 18 65 55 55 26 79 42 77 53 -5 26 -20 23 -113 -24z'
        />
        <path
          d='M77 981 c-36 -38 -59 -72 -66 -99 -32 -118 64 -220 184 -198 39 8
156 109 181 157 17 33 18 112 3 142 -22 42 -41 58 -56 46 -11 -10 -9 -17 8
-46 23 -36 27 -89 11 -119 -6 -11 -37 -45 -70 -77 -47 -47 -67 -60 -100 -64
-71 -10 -132 46 -132 122 0 31 9 46 60 99 62 65 70 80 46 89 -9 4 -36 -17 -69
-52z'
        />
        <path
          d='M154 625 c-10 -26 15 -135 47 -200 16 -33 47 -81 69 -107 47 -55 151
-125 197 -134 18 -3 33 -10 33 -14 0 -4 -36 -24 -80 -44 -73 -35 -95 -56 -71
-70 7 -5 200 85 228 106 9 7 -3 39 -45 124 -53 106 -72 129 -87 104 -3 -5 14
-49 39 -97 25 -48 44 -89 42 -91 -2 -1 -35 11 -72 29 -134 63 -231 190 -258
337 -12 65 -30 89 -42 57z'
        />
        <path
          d='M874 579 c-70 -27 -128 -79 -161 -147 -23 -47 -28 -70 -28 -132 1
-123 56 -215 161 -266 78 -38 190 -38 268 0 106 52 159 141 159 268 0 64 -5
87 -27 132 -66 135 -231 200 -372 145z m221 -47 c47 -24 95 -73 121 -122 26
-49 26 -171 0 -220 -26 -49 -74 -98 -121 -123 -31 -17 -58 -22 -115 -22 -85 0
-133 20 -186 77 -54 57 -69 95 -69 178 0 83 15 121 69 178 31 34 70 58 116 73
41 14 142 3 185 -19z'
        />
        <path
          d='M960 486 c0 -17 -7 -26 -25 -30 -24 -6 -55 -51 -55 -80 0 -25 46 -71
86 -85 60 -21 84 -39 84 -65 0 -31 -24 -50 -65 -50 -38 0 -75 28 -75 56 0 28
-34 19 -38 -10 -4 -25 46 -82 72 -82 8 0 16 -10 18 -22 2 -13 10 -23 18 -23 8
0 16 10 18 22 2 13 10 23 18 23 27 0 74 56 74 88 0 36 -24 58 -103 97 -51 25
-62 34 -62 55 0 58 97 66 117 10 5 -17 16 -30 23 -30 42 0 17 76 -31 96 -23 9
-34 21 -34 34 0 13 -7 20 -20 20 -14 0 -20 -7 -20 -24z'
        />
      </g>
    </svg>
  );
};

export const FormIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 24 24'
    >
      <path
        fill='#000000'
        d='M15 5h3l-1.5 2L15 5M5 2h14a2 2 0 0 1 2 2v16c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m0 2v4h14V4H5m0 16h14V10H5v10m2-8h10v2H7v-2m0 4h10v2H7v-2Z'
      />
    </svg>
  );
};

export const WARNING_IMAGE =
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKQlyPBzXQ7BXkK1BbzNP5-olpGU36BR_Qhw&usqp=CAU';
